/* KiekkoKingi filter module: search route. Generated from kk-native-filters.js. */
(function () {
  var WEIGHT_FILTER_PARAM = 'filter.p.m.my_fields.paino';
  var WEIGHT_FILTER_INPUT_SELECTOR =
    'input[name="' + WEIGHT_FILTER_PARAM + '"], input[name^="' + WEIGHT_FILTER_PARAM + '."]';
  var RANGE_NO_MATCH_PARAM = 'kk_native_range_no_match';

  function isWeightRangeMarker(value) {
    var parsed;
    var facetKey;

    try {
      parsed = JSON.parse(String(value || ''));
    } catch (error) {
      return false;
    }

    if (!Array.isArray(parsed) || !parsed.length) return false;

    facetKey = String(parsed[0] || '').replace(/^filter\.p\.m\./, '');
    return facetKey === 'my_fields.paino';
  }

  function removeDisallowedWeightState() {
    var url = new URL(window.location.href);
    var markerValues;
    var keptMarkerValues;
    var changed = false;

    Array.from(url.searchParams.keys()).forEach(function (name) {
      if (name === WEIGHT_FILTER_PARAM || name.indexOf(WEIGHT_FILTER_PARAM + '.') === 0) {
        url.searchParams.delete(name);
        changed = true;
      }
    });

    markerValues = url.searchParams.getAll(RANGE_NO_MATCH_PARAM);
    keptMarkerValues = markerValues.filter(function (value) {
      return !isWeightRangeMarker(value);
    });

    if (keptMarkerValues.length !== markerValues.length) {
      url.searchParams.delete(RANGE_NO_MATCH_PARAM);
      keptMarkerValues.forEach(function (value) {
        url.searchParams.append(RANGE_NO_MATCH_PARAM, value);
      });
      changed = true;
    }

    if (changed) {
      window.location.replace(url.pathname + url.search + url.hash);
    }
  }

  function removeDisallowedWeightControls(root) {
    var inputs = [];

    if (!root) return;

    if (root.matches && root.matches(WEIGHT_FILTER_INPUT_SELECTOR)) {
      inputs.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(WEIGHT_FILTER_INPUT_SELECTOR).forEach(function (input) {
        inputs.push(input);
      });
    }

    inputs.forEach(function (input) {
      var facet = input.closest && input.closest('[data-kk-facet], .search-filters__details-wrapper, [data-filter-group]');

      input.disabled = true;

      if (facet && facet.parentNode) {
        facet.parentNode.removeChild(facet);
      }
    });
  }

  function guardSearchWeightFilter() {
    removeDisallowedWeightControls(document);

    if (!window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            removeDisallowedWeightControls(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  removeDisallowedWeightState();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', guardSearchWeightFilter);
  } else {
    guardSearchWeightFilter();
  }
}());
function kkStripNativeRangeNoMatchRequestParam(urlValue) {
  var raw;
  var url;
  var isAbsolute;

  if (typeof urlValue !== 'string' && !(urlValue instanceof URL)) {
    return urlValue;
  }

  raw = String(urlValue);
  if (raw.indexOf('kk_native_range_no_match') === -1) {
    return urlValue;
  }

  try {
    url = new URL(raw, window.location.origin);
  } catch (error) {
    return urlValue;
  }

  url.searchParams.delete('kk_native_range_no_match');
  isAbsolute = /^[a-z][a-z\d+.-]*:/i.test(raw) || raw.indexOf('//') === 0;

  return isAbsolute ? url.href : url.pathname + url.search + url.hash;
}

(function () {
  var contextualPriceMaxCache = {};
  var contextualPriceMaxPendingRoots = {};
  var contextualPriceMaxRequests = {};
  var JUDGE_ME_PENDING_BADGE_SELECTOR = '.productgrid--item .jdgm-preview-badge:not(.jdgm--done-setup)';
  var JUDGE_ME_REFRESH_DELAY = 250;
  var JUDGE_ME_REFRESH_MAX_ATTEMPTS = 20;
  var JUDGE_ME_BASE_SCRIPT_PATH = 'widget/base.js';
  var JUDGE_ME_COMMON_SCRIPT_PATH = 'widget/common.js';
  var JUDGE_ME_BADGE_SCRIPT_PATH = 'widget/main.js';
  var JUDGE_ME_LEGACY_SCRIPT_PATH = 'shopify_v2.js';
  var judgeMeRefreshTimer = null;
  var judgeMeRefreshAttempts = 0;
  var judgeMeDoneSetupListening = false;

  function hasPendingJudgeMeSearchBadges() {
    return Boolean(document.querySelector(JUDGE_ME_PENDING_BADGE_SELECTOR));
  }

  function stopJudgeMeSearchRefresh() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }

    if (judgeMeDoneSetupListening) {
      document.removeEventListener('jdgm.doneSetup', handleJudgeMeSearchDoneSetup);
      judgeMeDoneSetupListening = false;
    }

    judgeMeRefreshAttempts = 0;
  }

  function isJudgeMeSearchScriptRequested(jdgm, path) {
    var requestedUrls = jdgm && jdgm.loadScript && jdgm.loadScript.requestedUrls;
    var normalizedPath = String(path || '').replace(/^\/+/, '');
    var flattenedPath = normalizedPath.replace(/\//g, '_');

    if (!Array.isArray(requestedUrls) || !normalizedPath) return false;

    return requestedUrls.some(function (url) {
      var cleanUrl = String(url || '').split(/[?#]/)[0];
      return cleanUrl.slice(-normalizedPath.length) === normalizedPath
        || cleanUrl.slice(-flattenedPath.length) === flattenedPath;
    });
  }

  function requestJudgeMeSearchScript(jdgm, path, useFullCdnUrl) {
    var cdnHost;
    var source;

    if (!jdgm || typeof jdgm.loadScript !== 'function' || isJudgeMeSearchScriptRequested(jdgm, path)) {
      return false;
    }

    cdnHost = String(jdgm.CDN_HOST || 'https://cdn.judge.me/').replace(/\/?$/, '/');
    source = useFullCdnUrl ? cdnHost + String(path || '') : path;

    try {
      jdgm.loadScript(source);
      return true;
    } catch (error) {
      return false;
    }
  }

  function ensureJudgeMeSearchBadgeRuntime() {
    var jdgm = window.jdgm;
    var settings = window.jdgmSettings || {};

    if (!jdgm || typeof jdgm.loadScript !== 'function') return false;
    if (typeof jdgm.customizeBadges === 'function') return true;

    if (!settings.widget_load_with_code_splitting) {
      requestJudgeMeSearchScript(jdgm, JUDGE_ME_LEGACY_SCRIPT_PATH, true);
      return true;
    }

    if (typeof jdgm.initializeWidgets === 'function') {
      requestJudgeMeSearchScript(jdgm, JUDGE_ME_BADGE_SCRIPT_PATH, true);
      return true;
    }

    if (typeof jdgm.$ === 'function') {
      requestJudgeMeSearchScript(jdgm, JUDGE_ME_COMMON_SCRIPT_PATH, false);
      return true;
    }

    requestJudgeMeSearchScript(jdgm, JUDGE_ME_BASE_SCRIPT_PATH, false);
    return true;
  }

  function runJudgeMeSearchRefresh() {
    var jdgm = window.jdgm;

    if (!hasPendingJudgeMeSearchBadges()) {
      return true;
    }

    if (!jdgm || typeof jdgm.customizeBadges !== 'function') {
      ensureJudgeMeSearchBadgeRuntime();
      return false;
    }

    try {
      jdgm.customizeBadges();
    } catch (error) {
      return false;
    }

    return !hasPendingJudgeMeSearchBadges();
  }

  function scheduleJudgeMeSearchRefresh() {
    judgeMeRefreshTimer = null;

    if (runJudgeMeSearchRefresh()) {
      stopJudgeMeSearchRefresh();
      return;
    }

    judgeMeRefreshAttempts += 1;
    if (judgeMeRefreshAttempts >= JUDGE_ME_REFRESH_MAX_ATTEMPTS) {
      stopJudgeMeSearchRefresh();
      return;
    }

    judgeMeRefreshTimer = window.setTimeout(scheduleJudgeMeSearchRefresh, JUDGE_ME_REFRESH_DELAY);
  }

  function handleJudgeMeSearchDoneSetup() {
    if (judgeMeRefreshTimer) {
      window.clearTimeout(judgeMeRefreshTimer);
      judgeMeRefreshTimer = null;
    }
    scheduleJudgeMeSearchRefresh();
  }

  function refreshJudgeMeSearchBadges() {
    stopJudgeMeSearchRefresh();

    if (!hasPendingJudgeMeSearchBadges()) {
      return;
    }

    document.addEventListener('jdgm.doneSetup', handleJudgeMeSearchDoneSetup);
    judgeMeDoneSetupListening = true;
    scheduleJudgeMeSearchRefresh();
  }

  document.addEventListener('kk:collection-search-complete', refreshJudgeMeSearchBadges);
  window.addEventListener('pagehide', stopJudgeMeSearchRefresh);

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    var formatted;

    if (!input) return;
    formatted = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
    input.value = formatted;
    input.setAttribute('value', formatted);
  }

  function clearFieldValue(input) {
    if (!input) return;
    input.value = '';
    input.removeAttribute('value');
  }

  function getFormattedRangeValue(value) {
    return Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, parts, lower, upper) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(parts.minInput, lower);
      setFieldValue(parts.maxInput, upper);
      return;
    }

    if (parts.minInput) {
      if (isAtRangeStart(lower, parts.min)) {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lower);
      }
    }

    if (parts.maxInput) {
      if (isAtRangeEnd(upper, parts.max)) {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upper);
      }
    }
  }

  function getRangeParts(root) {
    return {
      min: toNumber(root.dataset.kkRangeMin, 0),
      max: toNumber(root.dataset.kkRangeMax, 0),
      lower: root.querySelector('[data-kk-range-lower]'),
      upper: root.querySelector('[data-kk-range-upper]'),
      minInput: root.querySelector('[data-kk-range-min-input]'),
      maxInput: root.querySelector('[data-kk-range-max-input]')
    };
  }

  function getPriceParamNames(root) {
    var parts = getRangeParts(root);

    return {
      min: parts.minInput && parts.minInput.name ? parts.minInput.name : 'filter.v.price.gte',
      max: parts.maxInput && parts.maxInput.name ? parts.maxInput.name : 'filter.v.price.lte'
    };
  }

  function buildContextualPriceMaxUrl(root) {
    var form = root.closest('[data-filter-form]');
    var paramsToRefresh = {};
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    url.searchParams.delete(priceParams.min);
    url.searchParams.delete(priceParams.max);

    if (form) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field && field.name) {
          paramsToRefresh[field.name] = true;
        }
      });

      Object.keys(paramsToRefresh).forEach(function (name) {
        url.searchParams.delete(name);
      });

      new URLSearchParams(new FormData(form)).forEach(function (value, name) {
        if (name === priceParams.min || name === priceParams.max || String(value || '') === '') {
          return;
        }

        url.searchParams.append(name, value);
      });
    }

    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function buildContextualPriceMaxUrlFromUrl(sourceUrl) {
    var url;

    try {
      url = new URL(sourceUrl || window.location.href, window.location.origin);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function getExplicitPriceSelection(root, sourceUrl) {
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href, window.location.origin);
    } catch (error) {
      url = null;
    }

    if (!url) {
      return {
        min: false,
        max: false
      };
    }

    return {
      min: String(url.searchParams.get(priceParams.min) || '') !== '',
      max: String(url.searchParams.get(priceParams.max) || '') !== ''
    };
  }

  function forEachProductPriceInScope(scope, callback) {
    var cards;

    if (!scope || !scope.querySelectorAll || typeof callback !== 'function') {
      return;
    }

    cards = scope.querySelectorAll('[data-product-item][data-product-price]');

    if (cards.length) {
      cards.forEach(function (card) {
        var price = toNumber(card.getAttribute('data-product-price'), 0);
        var priceMax = toNumber(card.getAttribute('data-product-price-max'), price);

        callback(price, priceMax);
      });
      return;
    }

    // Backwards-compatible fallback for cached or app-provided card markup.
    scope.querySelectorAll('script[data-product-data]').forEach(function (script) {
      var product;
      var price;
      var priceMax;

      try {
        product = JSON.parse(script.textContent || '{}');
      } catch (error) {
        product = {};
      }

      price = toNumber(product.price || 0, 0);
      priceMax = toNumber(product.price_max || product.price || 0, price);
      callback(price, priceMax);
    });
  }

  function readMaxProductPriceFromScope(scope) {
    var maxPrice = 0;

    forEachProductPriceInScope(scope, function (price, priceMax) {
      if (priceMax > maxPrice) {
        maxPrice = priceMax;
      }
    });

    return maxPrice;
  }

  function readMinProductPriceFromScope(scope) {
    var minPrice = null;

    forEachProductPriceInScope(scope, function (price) {
      if (price <= 0) return;
      if (minPrice === null || price < minPrice) {
        minPrice = price;
      }
    });

    return minPrice === null ? 0 : minPrice;
  }

  function readMaxProductPriceFromHtml(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');

    return readMaxProductPriceFromScope(doc);
  }

  function setMaxAttribute(input, value) {
    if (input) {
      input.setAttribute('max', getFormattedRangeValue(value));
    }
  }

  function formatNumberForPriceTag(value, sample) {
    var numericValue = Math.round(toNumber(value, 0) * 100) / 100;
    var sampleText = String(sample || '');
    var firstDigit = sampleText.search(/\d/);
    var lastDigit = Math.max(
      sampleText.lastIndexOf('0'),
      sampleText.lastIndexOf('1'),
      sampleText.lastIndexOf('2'),
      sampleText.lastIndexOf('3'),
      sampleText.lastIndexOf('4'),
      sampleText.lastIndexOf('5'),
      sampleText.lastIndexOf('6'),
      sampleText.lastIndexOf('7'),
      sampleText.lastIndexOf('8'),
      sampleText.lastIndexOf('9')
    );
    var prefix = firstDigit > -1 ? sampleText.slice(0, firstDigit) : '';
    var suffix = lastDigit > -1 ? sampleText.slice(lastDigit + 1) : '';
    var decimalSeparator = sampleText.lastIndexOf(',') > sampleText.lastIndexOf('.') ? ',' : '.';
    var thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    var fixed = numericValue.toFixed(2).split('.');
    var integerPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    return prefix + integerPart + decimalSeparator + fixed[1] + suffix;
  }

  function updateActivePriceFilterTags(root, contextualMax, sourceUrl) {
    var explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    var doc = root && root.ownerDocument ? root.ownerDocument : document;

    if (explicitPriceSelection.max) {
      return;
    }

    doc.querySelectorAll('[data-kk-active-price-filter]').forEach(function (link) {
      var text = link.querySelector('.filter-text');
      var parts;
      var maxText;

      if (!text || link.getAttribute('data-kk-active-price-has-max') === 'true') {
        return;
      }

      parts = text.textContent.split(/\s+-\s+/);

      if (parts.length < 2) {
        return;
      }

      maxText = formatNumberForPriceTag(contextualMax, parts[1]);
      text.textContent = parts[0] + ' - ' + maxText;
    });
  }

  function applyContextualPriceMax(root, maxPriceCents, sourceUrl) {
    var contextualMax = Math.ceil(toNumber(maxPriceCents, 0) / 100);
    var parts;
    var oldMax;
    var currentLower;
    var currentUpper;
    var currentMaxInput;
    var explicitPriceSelection;
    var wasAtOldMax;
    var bounds;

    if (!root || !root.hasAttribute('data-kk-price-range') || contextualMax <= 0) {
      return;
    }

    parts = getRangeParts(root);
    oldMax = parts.max;
    contextualMax = Math.max(contextualMax, parts.min);

    currentLower = toNumber(parts.lower && parts.lower.value, parts.min);
    currentUpper = toNumber(parts.upper && parts.upper.value, oldMax);
    currentMaxInput = parts.maxInput && parts.maxInput.value !== '' ?
      toNumber(parts.maxInput.value, null) :
      null;
    explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    wasAtOldMax = !explicitPriceSelection.max ||
      currentMaxInput === null ||
      isAtRangeEnd(currentUpper, oldMax) ||
      isAtRangeEnd(currentMaxInput, oldMax);

    root.dataset.kkRangeMax = getFormattedRangeValue(contextualMax);

    setMaxAttribute(parts.minInput, contextualMax);
    setMaxAttribute(parts.maxInput, contextualMax);
    setMaxAttribute(parts.lower, contextualMax);
    setMaxAttribute(parts.upper, contextualMax);

    if (parts.maxInput) {
      parts.maxInput.placeholder = getFormattedRangeValue(contextualMax);
      parts.maxInput.setAttribute('placeholder', getFormattedRangeValue(contextualMax));
      if (wasAtOldMax) {
        clearFieldValue(parts.maxInput);
      } else if (currentMaxInput !== null && currentMaxInput > contextualMax) {
        setFieldValue(parts.maxInput, contextualMax);
      }
    }

    if (!explicitPriceSelection.min) {
      clearFieldValue(parts.minInput);
      if (parts.lower) {
        setFieldValue(parts.lower, parts.min);
      }
    } else if (parts.minInput && toNumber(parts.minInput.value, parts.min) > contextualMax) {
      setFieldValue(parts.minInput, contextualMax);
    }

    if (parts.lower && currentLower > contextualMax) {
      setFieldValue(parts.lower, contextualMax);
    }

    if (parts.upper && (wasAtOldMax || currentUpper > contextualMax)) {
      setFieldValue(parts.upper, contextualMax);
    }

    bounds = root.querySelector('.kk-range-filter__bounds span:last-child');
    if (bounds) {
      bounds.textContent = getFormattedRangeValue(contextualMax);
    }

    updateActivePriceFilterTags(root, contextualMax, sourceUrl);
    paintRange(root);
  }

  function flushContextualPriceMax(url, maxPriceCents) {
    var roots = contextualPriceMaxPendingRoots[url] || [];

    roots.forEach(function (root) {
      if (document.documentElement.contains(root)) {
        applyContextualPriceMax(root, maxPriceCents, url);
      }
    });

    contextualPriceMaxPendingRoots[url] = [];
  }

  function clearContextualPriceMaxPending(url) {
    contextualPriceMaxPendingRoots[url] = [];
  }

  function requestContextualPriceMax(url) {
    if (!url) {
      return Promise.resolve(0);
    }

    if (contextualPriceMaxCache[url]) {
      return Promise.resolve(contextualPriceMaxCache[url]);
    }

    if (contextualPriceMaxRequests[url]) {
      return contextualPriceMaxRequests[url];
    }

    contextualPriceMaxRequests[url] = fetch(kkStripNativeRangeNoMatchRequestParam(url), {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Contextual price max request failed');
      }

      return response.text();
    }).then(function (markup) {
      var maxPriceCents = readMaxProductPriceFromHtml(markup);

      if (maxPriceCents > 0) {
        contextualPriceMaxCache[url] = maxPriceCents;
      }

      return maxPriceCents;
    }).catch(function () {
      return 0;
    }).then(function (maxPriceCents) {
      delete contextualPriceMaxRequests[url];
      return maxPriceCents;
    });

    return contextualPriceMaxRequests[url];
  }

  function primeContextualPriceMaxForUrl(sourceUrl) {
    return requestContextualPriceMax(buildContextualPriceMaxUrlFromUrl(sourceUrl));
  }

  function applyContextualPriceMaxToScope(scope, maxPriceCents, sourceUrl) {
    if (!scope || !scope.querySelectorAll || !maxPriceCents) {
      return;
    }

    scope.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      applyContextualPriceMax(root, maxPriceCents, sourceUrl);
    });
  }

  function updateContextualPriceMax(root) {
    var url;
    var visibleMaxPriceCents;

    if (!root || !root.hasAttribute('data-kk-price-range')) {
      return;
    }

    url = buildContextualPriceMaxUrl(root);

    if (!url) {
      return;
    }

    visibleMaxPriceCents = readMaxProductPriceFromScope(document);
    if (visibleMaxPriceCents > getRangeParts(root).max * 100) {
      applyContextualPriceMax(root, visibleMaxPriceCents, url);
    }

    if (contextualPriceMaxCache[url]) {
      applyContextualPriceMax(root, contextualPriceMaxCache[url], url);
      return;
    }

    if (!contextualPriceMaxPendingRoots[url]) {
      contextualPriceMaxPendingRoots[url] = [];
    }

    contextualPriceMaxPendingRoots[url].push(root);

    requestContextualPriceMax(url).then(function (maxPriceCents) {
      if (maxPriceCents > 0) {
        flushContextualPriceMax(url, maxPriceCents);
      } else {
        clearContextualPriceMaxPending(url);
      }
    });
  }

  function readRange(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.lower && parts.lower.value, parts.min);
    var upper = toNumber(parts.upper && parts.upper.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.lower || document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    return {
      parts: parts,
      lower: lower,
      upper: upper
    };
  }

  function paintRange(root) {
    var range = readRange(root);
    var parts = range.parts;

    if (parts.lower) setFieldValue(parts.lower, range.lower);
    if (parts.upper) setFieldValue(parts.upper, range.upper);
    setRangeFieldValues(root, parts, range.lower, range.upper);
    updateRangeTooltips(root);
  }

  function updateRangeTooltips(root) {
    if (!root) return;
    var slider = root.querySelector('[data-kk-range-track]') || root.querySelector('.kk-range-filter__slider');
    if (!slider) return;

    var prefix = slider.getAttribute('data-kk-tooltip-prefix') || '';
    var suffix = slider.getAttribute('data-kk-tooltip-suffix') || '';
    var lower = slider.querySelector('[data-kk-range-lower]');
    var upper = slider.querySelector('[data-kk-range-upper]');
    var tooltipLower = slider.querySelector('[data-kk-range-tooltip="lower"]');
    var tooltipUpper = slider.querySelector('[data-kk-range-tooltip="upper"]');

    function update(input, tooltip) {
      if (!input || !tooltip) return;
      var inputMin = toNumber(input.min, 0);
      var inputMax = toNumber(input.max, 100);
      var value = toNumber(input.value, inputMin);
      var span = inputMax - inputMin;
      var percent = span > 0 ? ((value - inputMin) / span * 100) : 0;
      var thumbHalf = 13;
      var offset = thumbHalf * (1 - percent / 50);
      tooltip.style.left = 'calc(' + percent + '% + ' + offset.toFixed(2) + 'px)';
      tooltip.textContent = prefix + value + suffix;
    }

    update(lower, tooltipLower);
    update(upper, tooltipUpper);
  }

  function syncSliderFromFields(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.minInput && parts.minInput.value, parts.min);
    var upper = toNumber(parts.maxInput && parts.maxInput.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    if (parts.lower) setFieldValue(parts.lower, lower);
    if (parts.upper) setFieldValue(parts.upper, upper);
    paintRange(root);
  }

  function dispatchNativeChange(input) {
    if (!input) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setNativeRangeNoMatchState(root, active, lower, upper) {
    var previous = root.hasAttribute('data-kk-native-range-no-match') ?
      [
        root.getAttribute('data-kk-native-range-no-match-lower') || '',
        root.getAttribute('data-kk-native-range-no-match-upper') || ''
      ].join('\u0000') :
      '';
    var next = active ? [String(lower), String(upper)].join('\u0000') : '';

    if (active) {
      root.setAttribute('data-kk-native-range-no-match', '');
      root.setAttribute('data-kk-native-range-no-match-lower', String(lower));
      root.setAttribute('data-kk-native-range-no-match-upper', String(upper));
    } else {
      root.removeAttribute('data-kk-native-range-no-match');
      root.removeAttribute('data-kk-native-range-no-match-lower');
      root.removeAttribute('data-kk-native-range-no-match-upper');
    }

    return previous !== next;
  }

  function commitNativeRange(root) {
    var range = readRange(root);
    var options = root.querySelectorAll('[data-kk-native-range-option]');
    var fullRange = range.lower <= range.parts.min && range.upper >= range.parts.max;
    var changed = false;
    var eventTarget = null;
    var matchingOptionCount = 0;

    options.forEach(function (option) {
      var value = toNumber(option.dataset.kkRangeValue, range.parts.min);
      var shouldCheck = !fullRange && value >= range.lower && value <= range.upper && !option.disabled;

      if (shouldCheck) {
        matchingOptionCount += 1;
      }

      if (option.checked !== shouldCheck) {
        option.checked = shouldCheck;
        changed = true;
        if (!eventTarget) eventTarget = option;
      }
    });

    if (setNativeRangeNoMatchState(
      root,
      !fullRange && matchingOptionCount === 0,
      range.lower,
      range.upper
    )) {
      changed = true;
    }

    paintRange(root);

    if (changed) {
      dispatchNativeChange(eventTarget || options[0]);
    }
  }

  function commitPriceRange(root) {
    var range = readRange(root);
    var minInput = range.parts.minInput;
    var maxInput = range.parts.maxInput;
    var changeTarget;

    setRangeFieldValues(root, range.parts, range.lower, range.upper);
    changeTarget = minInput && minInput.value !== '' ? minInput : maxInput || minInput;
    dispatchNativeChange(changeTarget);
  }

  function handleRangeInput(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }
  }

  function handleRangeChange(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }

    if (root.hasAttribute('data-kk-native-range')) {
      commitNativeRange(root);
    } else if (target.matches('[data-kk-range-lower], [data-kk-range-upper]')) {
      commitPriceRange(root);
    }
  }

  function handleFacetSearch(event) {
    var input = event.target.closest('[data-kk-filter-search]');
    if (!input) return;

    var facet = input.closest('[data-kk-facet]');
    var term = input.value.trim().toLowerCase();
    var options = facet ? facet.querySelectorAll('[data-kk-filter-option]') : [];
    var toggle = facet ? facet.querySelector('[data-filter-toggle]') : null;
    var filterGroup = facet ? facet.querySelector('[data-kk-filter-list]') : null;
    var expanded = toggle && toggle.getAttribute('data-filter-toggle') === 'true';

    options.forEach(function (option) {
      var text = (option.getAttribute('data-kk-filter-search-text') || option.textContent || '').trim().toLowerCase();
      var matches = !term || text.indexOf(term) !== -1;

      option.hidden = !matches;
      option.classList.toggle('kk-filter-option--search-hidden', !matches);

      if (term) {
        option.classList.remove('filter-item--hidden');
      } else if (option.hasAttribute('data-hidden-default')) {
        option.classList.toggle('filter-item--hidden', !expanded);
      } else {
        option.classList.remove('filter-item--hidden');
      }
    });

    if (toggle) {
      var toggleItem = toggle.closest('.filter-item');

      if (toggleItem) {
        toggleItem.hidden = Boolean(term) || toggleItem.hasAttribute('data-kk-no-eligible-overflow');
        toggleItem.classList.toggle('kk-filter-option--search-hidden', Boolean(term));
      }
    }

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', Boolean(term) || Boolean(expanded));
    }
  }

  function shouldPrimeContextualPriceMax(target) {
    var isMobileFilterModal = Boolean(
      target &&
      target.closest('[data-modal-container].modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible') &&
      (window.matchMedia ? window.matchMedia('(max-width: 859px)').matches : window.innerWidth < 860)
    );

    return Boolean(
      target &&
      !isMobileFilterModal &&
      !target.closest('[data-kk-price-range]') &&
      target.closest('[data-filter-form]') &&
      target.closest(
        '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
      )
    );
  }

  function primeContextualPriceMax(target) {
    var form = target && target.closest('[data-filter-form]');
    var priceRange = form && form.querySelector('[data-kk-price-range]');

    if (!shouldPrimeContextualPriceMax(target) || !priceRange) {
      return;
    }

    updateContextualPriceMax(priceRange);
  }

  function initializeRanges(root) {
    root.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (range) {
      if (range.hasAttribute('data-kk-price-range')) {
        updateContextualPriceMax(range);
      }

      paintRange(range);
    });
    syncStaticSearchRangeFacets(root);
  }

  function syncStaticSearchRangeFacets(root) {
    var ranges = [];

    if (root.matches && root.matches('[data-kk-search-sidebar-filters] [data-kk-native-range]')) {
      ranges.push(root);
    }

    root.querySelectorAll('[data-kk-search-sidebar-filters] [data-kk-native-range]').forEach(function (range) {
      ranges.push(range);
    });

    ranges.forEach(function (range) {
      var min = toNumber(range.dataset.kkRangeMin, null);
      var max = toNumber(range.dataset.kkRangeMax, null);
      var facet = range.closest('[data-kk-facet]');

      if (!facet || min === null || max === null) return;

      facet.hidden = min === max;
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeInput(event);
    }

    handleFacetSearch(event);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeChange(event);
    }

    primeContextualPriceMax(event.target);
  });

  document.addEventListener('kk:sync-native-range-ui', function (event) {
    var target = event.target;
    var root = target && target.closest ?
      target.closest('[data-kk-native-range], [data-kk-price-range]') :
      null;

    if (root) {
      paintRange(root);
    }
  });

  function handleFilterToggleClick(event) {
    var toggle = event.target.closest && event.target.closest('[data-filter-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    var siblingsVisible = toggle.getAttribute('data-filter-toggle') === 'true';
    var filterGroup = toggle.closest('.filter-group, [data-filter-group], ul');
    var hiddenFilters = filterGroup ? filterGroup.querySelectorAll('[data-hidden-default]') : [];
    var seeMoreText =
      toggle.getAttribute('data-kk-see-more-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
      'See more';
    var seeLessText =
      toggle.getAttribute('data-kk-see-less-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_less) ||
      'See less';

    hiddenFilters.forEach(function (filter) {
      if (siblingsVisible) {
        filter.classList.add('filter-item--hidden');
      } else {
        filter.classList.remove('filter-item--hidden');
      }
    });

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', !siblingsVisible);
    }

    toggle.textContent = siblingsVisible ? seeMoreText : seeLessText;
    toggle.setAttribute('data-filter-toggle', siblingsVisible ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', siblingsVisible ? 'false' : 'true');
  }

  document.addEventListener('click', handleFilterToggleClick, true);

  window.kkContextualPriceMax = {
    applyToScope: applyContextualPriceMaxToScope,
    primeForUrl: primeContextualPriceMaxForUrl
  };

  function syncPriceSliderFromUrl(root) {
    if (!root || !root.hasAttribute || !root.hasAttribute('data-kk-price-range')) return;

    var parts = getRangeParts(root);
    var params = new URLSearchParams(window.location.search);
    var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
    var lteName = (parts.maxInput && parts.maxInput.name) || 'filter.v.price.lte';
    var gte = params.get(gteName);
    var lte = params.get(lteName);
    var lowerVal = (gte !== null && gte !== '') ? clamp(toNumber(gte, parts.min), parts.min, parts.max) : parts.min;
    var upperVal = (lte !== null && lte !== '') ? clamp(toNumber(lte, parts.max), parts.min, parts.max) : parts.max;

    if (parts.lower) setFieldValue(parts.lower, lowerVal);
    if (parts.upper) setFieldValue(parts.upper, upperVal);

    if (parts.minInput) {
      if (gte === null || gte === '') {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lowerVal);
      }
    }

    if (parts.maxInput) {
      if (lte === null || lte === '') {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upperVal);
      }
    }

    paintRange(root);
  }

  function syncAllPriceSlidersFromUrl() {
    document.querySelectorAll('[data-kk-price-range]').forEach(syncPriceSliderFromUrl);
  }

  function syncPriceRangeMinFromVisibleProducts() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) {
      return;
    }

    var minCents = readMinProductPriceFromScope(document);
    var minEuros = Math.floor(toNumber(minCents, 0) / 100);

    if (minEuros <= 0) return;

    document.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      var parts = getRangeParts(root);
      var maxValue = parts.max;
      var clampedMin = Math.max(0, Math.min(minEuros, maxValue));
      var formatted = getFormattedRangeValue(clampedMin);

      root.dataset.kkRangeMin = formatted;

      if (parts.minInput) {
        parts.minInput.setAttribute('min', formatted);
        parts.minInput.placeholder = formatted;
        parts.minInput.setAttribute('placeholder', formatted);
      }
      if (parts.maxInput) parts.maxInput.setAttribute('min', formatted);
      if (parts.lower) parts.lower.setAttribute('min', formatted);
      if (parts.upper) parts.upper.setAttribute('min', formatted);

      var boundsFirst = root.querySelector('.kk-range-filter__bounds span:first-child');
      if (boundsFirst) {
        boundsFirst.textContent = formatted;
      }

      var params = new URLSearchParams(window.location.search);
      var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
      var gte = params.get(gteName);
      if ((gte === null || gte === '') && parts.lower) {
        setFieldValue(parts.lower, clampedMin);
      }

      paintRange(root);
    });
  }

  function syncAfterUrlOrDomChange() {
    syncAllPriceSlidersFromUrl();
    syncPriceRangeMinFromVisibleProducts();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeRanges(document);
    syncPriceRangeMinFromVisibleProducts();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initializeRanges(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.querySelectorAll('[data-results-container]').forEach(function (container) {
      var debounceTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(syncAfterUrlOrDomChange, 50);
      }).observe(container, { childList: true });
    });

    document.querySelectorAll('[data-modal-container]').forEach(function (modalContainer) {
      var wasOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
      new MutationObserver(function () {
        var isOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
        if (isOpenForFilters && !wasOpenForFilters) {
          window.setTimeout(syncAfterUrlOrDomChange, 50);
        }
        wasOpenForFilters = isOpenForFilters;
      }).observe(modalContainer, { attributes: true, attributeFilter: ['class'] });
    });

    var originalPushState = window.history.pushState;
    var pushStateTimer = null;
    window.history.pushState = function () {
      var result = originalPushState.apply(this, arguments);
      window.clearTimeout(pushStateTimer);
      pushStateTimer = window.setTimeout(syncAfterUrlOrDomChange, 80);
      return result;
    };

    window.addEventListener('popstate', function () {
      window.setTimeout(syncAfterUrlOrDomChange, 80);
    });
  });
}());

(function () {
  var suppressThemeScrollUntil = 0;

  function isHtmlBodyCollection(collection) {
    var matches = false;

    collection.each(function () {
      var tagName = this.tagName ? this.tagName.toLowerCase() : '';

      if (tagName === 'html' || tagName === 'body') {
        matches = true;
      }
    });

    return matches;
  }

  function patchJQueryAnimate(jQueryInstance) {
    if (!jQueryInstance || !jQueryInstance.fn || jQueryInstance.fn.kkFilterScrollPatched) {
      return;
    }

    var originalAnimate = jQueryInstance.fn.animate;

    jQueryInstance.fn.animate = function (properties) {
      var isThemeScrollToTop = properties &&
        Object.prototype.hasOwnProperty.call(properties, 'scrollTop') &&
        isHtmlBodyCollection(this);

      if (isThemeScrollToTop && Date.now() < suppressThemeScrollUntil) {
        return this;
      }

      return originalAnimate.apply(this, arguments);
    };

    jQueryInstance.fn.kkFilterScrollPatched = true;
  }

  function patchAvailableJQuery() {
    patchJQueryAnimate(window.jQuery);
    patchJQueryAnimate(window.$);
  }

  function suppressThemeScrollToTop() {
    suppressThemeScrollUntil = Date.now() + 4000;
    patchAvailableJQuery();
  }

  function isFilterChangeTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isFilterChangeTarget(event.target)) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && event.target.closest('[data-filter-range]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-filter-remove]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', patchAvailableJQuery);
}());

(function () {
  var pendingSnapshot = null;
  var replayingPendingSnapshot = false;
  var pendingFlushTimer = null;

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getFilterForm() {
    var modal = document.querySelector('[data-modal-container]');
    var modalForm = modal && modal.querySelector('[data-filter-form]');

    if (modalForm && document.body.classList.contains('modal-visible')) {
      return modalForm;
    }

    return document.querySelector('[data-filter-form]');
  }

  function getResultsContainer() {
    return document.querySelector('[data-results-container]');
  }

  function getSidebarContainer() {
    return document.querySelector('[data-product-grid-sidebar]');
  }

  function isFilterProcessing() {
    var results = getResultsContainer();
    var sidebar = getSidebarContainer();

    return Boolean(
      results && results.classList.contains('processing--filter') ||
      sidebar && sidebar.classList.contains('processing--filter')
    );
  }

  function setFilterProcessing(isProcessing) {
    var sidebar = getSidebarContainer();

    if (sidebar) {
      sidebar.classList.toggle('processing--filter', isProcessing);
    }

    syncFilterLoadingIcons();
  }

  function isMobileFilterSpinnerUi() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function clearFilterLoadingIconPosition(icon) {
    if (!icon) {
      return;
    }

    icon.style.removeProperty('position');
    icon.style.removeProperty('left');
    icon.style.removeProperty('top');
    icon.style.removeProperty('right');
    icon.style.removeProperty('bottom');
    icon.style.removeProperty('margin-left');
  }

  function getPrimaryFilterLoadingIcon(container) {
    var children;
    var index;

    if (!container || !container.children) {
      return null;
    }

    children = container.children;

    for (index = 0; index < children.length; index += 1) {
      if (
        children[index].classList &&
        children[index].classList.contains('kk-primary-grid-loader')
      ) {
        return children[index];
      }
    }

    return null;
  }

  function positionFilterLoadingIcon(container) {
    var icon = getPrimaryFilterLoadingIcon(container);
    var viewport = window.visualViewport;
    var centerLeft;
    var centerTop;
    var width;
    var height;

    if (!icon) {
      return;
    }

    if (!isMobileFilterSpinnerUi()) {
      clearFilterLoadingIconPosition(icon);
      return;
    }

    centerLeft = viewport ? viewport.offsetLeft + viewport.width / 2 : window.innerWidth / 2;
    centerTop = viewport ? viewport.offsetTop + viewport.height / 2 : window.innerHeight / 2;
    width = icon.getBoundingClientRect().width || icon.offsetWidth || 64;
    height = icon.getBoundingClientRect().height || icon.offsetHeight || 64;

    icon.style.setProperty('position', 'fixed', 'important');
    icon.style.setProperty('left', centerLeft - width / 2 + 'px', 'important');
    icon.style.setProperty('top', centerTop - height / 2 + 'px', 'important');
    icon.style.setProperty('right', 'auto', 'important');
    icon.style.setProperty('bottom', 'auto', 'important');
    icon.style.setProperty('margin-left', '0', 'important');
  }

  function syncFilterLoadingIcons() {
    return;
  }

  function getFieldKey(field) {
    return field.name + '\u0000' + (field.value || '');
  }

  function getRangeKey(root) {
    var option = root.querySelector('[data-kk-native-range-option]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (option && option.name) {
      return option.name;
    }

    if (minInput && maxInput && minInput.name && maxInput.name) {
      return minInput.name + '|' + maxInput.name;
    }

    return '';
  }

  function getFormQuery(form) {
    return form ? new URLSearchParams(new FormData(form)).toString() : '';
  }

  function snapshotRange(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var rangeLower = toNumber(lower && lower.value, toNumber(minInput && minInput.value, min));
    var rangeUpper = toNumber(upper && upper.value, toNumber(maxInput && maxInput.value, max));

    rangeLower = clamp(rangeLower, min, max);
    rangeUpper = clamp(rangeUpper, min, max);

    if (rangeLower > rangeUpper) {
      rangeUpper = rangeLower;
    }

    return {
      key: getRangeKey(root),
      lower: rangeLower,
      upper: rangeUpper
    };
  }

  function snapshotFilterState() {
    var form = getFilterForm();
    var checkboxes = {};
    var fields = {};
    var ranges = [];

    if (!form) {
      return null;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        checkboxes[getFieldKey(field)] = field.checked;
      } else {
        fields[field.name] = field.value;
      }
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var range = snapshotRange(root);

      if (range.key) {
        ranges.push(range);
      }
    });

    return {
      checkboxes: checkboxes,
      fields: fields,
      ranges: ranges,
      query: getFormQuery(form)
    };
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(minInput, lower);
      setFieldValue(maxInput, upper);
      return;
    }

    if (minInput) {
      if (isAtRangeStart(lower, min)) {
        minInput.value = '';
      } else {
        setFieldValue(minInput, lower);
      }
    }

    if (maxInput) {
      if (isAtRangeEnd(upper, max)) {
        maxInput.value = '';
      } else {
        setFieldValue(maxInput, upper);
      }
    }
  }

  function applyRangeState(root, state) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = clamp(toNumber(state.lower, min), min, max);
    var upper = clamp(toNumber(state.upper, max), min, max);
    var lowerSlider = root.querySelector('[data-kk-range-lower]');
    var upperSlider = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (lower > upper) {
      upper = lower;
    }

    if (lowerSlider) lowerSlider.value = lower;
    if (upperSlider) upperSlider.value = upper;
    setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max);

    if (root.hasAttribute('data-kk-native-range')) {
      var fullRange = lower <= min && upper >= max;
      var matchingOptionCount = 0;

      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        var value = toNumber(option.dataset.kkRangeValue, min);
        var shouldCheck = !fullRange && value >= lower && value <= upper && !option.disabled;

        option.checked = shouldCheck;
        if (shouldCheck) {
          matchingOptionCount += 1;
        }
      });

      setNativeRangeNoMatchState(root, !fullRange && matchingOptionCount === 0, lower, upper);
    }

    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function applySnapshot(snapshot) {
    var form = getFilterForm();
    var rangesByKey = {};

    if (!form || !snapshot) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Boolean(snapshot.checkboxes[getFieldKey(field)]);
      } else if (Object.prototype.hasOwnProperty.call(snapshot.fields, field.name)) {
        field.value = snapshot.fields[field.name];
      }
    });

    snapshot.ranges.forEach(function (range) {
      rangesByKey[range.key] = range;
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var key = getRangeKey(root);

      if (key && rangesByKey[key]) {
        applyRangeState(root, rangesByKey[key]);
      }
    });

    return true;
  }

  function findSyntheticChangeTarget(form) {
    return form.querySelector('[data-filter-checkbox]') ||
      form.querySelector('[data-filter-range]') ||
      form.querySelector('[name]');
  }

  function dispatchCombinedFilterChange(snapshot) {
    var form = getFilterForm();
    var target;

    if (!form || !snapshot) {
      setFilterProcessing(false);
      return;
    }

    if (!applySnapshot(snapshot)) {
      setFilterProcessing(false);
      return;
    }

    if (getFormQuery(form) === snapshot.query && window.location.search.indexOf(snapshot.query) !== -1) {
      setFilterProcessing(false);
      return;
    }

    target = findSyntheticChangeTarget(form);

    if (!target) {
      setFilterProcessing(false);
      return;
    }

    replayingPendingSnapshot = true;
    setFilterProcessing(true);
    target.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(function () {
      replayingPendingSnapshot = false;
    }, 0);
  }

  function flushPendingSnapshot() {
    var snapshot;

    window.clearTimeout(pendingFlushTimer);

    if (!pendingSnapshot || isFilterProcessing()) {
      return;
    }

    snapshot = pendingSnapshot;
    pendingSnapshot = null;
    dispatchCombinedFilterChange(snapshot);
  }

  function queuePendingSnapshot() {
    if (replayingPendingSnapshot) {
      return;
    }

    window.setTimeout(function () {
      if (!isFilterProcessing()) {
        return;
      }

      pendingSnapshot = snapshotFilterState() || pendingSnapshot;
      setFilterProcessing(true);
    }, 0);
  }

  function isNativeFilterTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      syncFilterLoadingIcons();

      if (!pendingSnapshot) {
        return;
      }

      window.clearTimeout(pendingFlushTimer);
      pendingFlushTimer = window.setTimeout(flushPendingSnapshot, 30);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncFilterLoadingIcons);
    window.visualViewport.addEventListener('scroll', syncFilterLoadingIcons);
  }

  window.addEventListener('resize', syncFilterLoadingIcons);
  syncFilterLoadingIcons();
}());

(function () {
  var activeDeferredInstance = null;
  var pendingDeferredApplyInstance = null;
  var liveFacetTimer = null;
  var liveFacetController = null;
  var liveFacetRequestId = 0;
  var liveFacetSessionId = 0;
  var liveFacetSessionOpen = false;
  var liveFacetActiveQuery = '';
  var liveFacetActiveForm = null;
  var liveFacetCache = new Map();
  var liveFacetCacheOrder = [];
  var liveFacetLastValidSelection = null;
  var liveFacetLastValidForm = null;
  var liveFacetLastValidCount = null;
  var liveFacetPointerTargets = new Map();
  var liveFacetPointerCounts = new WeakMap();
  var liveFacetPendingOrders = new WeakMap();
  var liveFacetLatestOrders = new WeakMap();
  var LIVE_FACET_DEBOUNCE_MS = 200;
  var LIVE_FACET_CACHE_LIMIT = 12;
  var SEARCH_RECOVERY_SORT = 'price-ascending';
  var SEARCH_RECOVERY_MAX_PAGES = 32;
  var NATIVE_RANGE_NO_MATCH_PARAM = 'kk_native_range_no_match';

  function getNativeRangeKey(root) {
    var option = root && root.querySelector('[data-kk-native-range-option][name]');

    return option && option.name ? option.name : '';
  }

  function findNativeRangeByKey(form, key) {
    var found = null;

    if (!form || !key) {
      return null;
    }

    Array.prototype.some.call(form.querySelectorAll('[data-kk-native-range]'), function (root) {
      if (getNativeRangeKey(root) === key) {
        found = root;
        return true;
      }

      return false;
    });

    return found;
  }

  function clearNativeRangeNoMatchState(root) {
    if (!root) return;

    root.removeAttribute('data-kk-native-range-no-match');
    root.removeAttribute('data-kk-native-range-no-match-lower');
    root.removeAttribute('data-kk-native-range-no-match-upper');
  }

  function readNativeRangeNoMatchState(root) {
    var key;
    var lower;
    var upper;

    if (!root || !root.hasAttribute('data-kk-native-range-no-match')) {
      return null;
    }

    key = getNativeRangeKey(root);
    lower = toNumber(root.getAttribute('data-kk-native-range-no-match-lower'), NaN);
    upper = toNumber(root.getAttribute('data-kk-native-range-no-match-upper'), NaN);

    if (!key || !Number.isFinite(lower) || !Number.isFinite(upper)) {
      return null;
    }

    if (lower > upper) {
      upper = lower;
    }

    return {
      key: key,
      lower: lower,
      upper: upper
    };
  }

  function collectNativeRangeNoMatchStates(form) {
    var states = [];
    var seen = {};

    if (!form) {
      return states;
    }

    form.querySelectorAll('[data-kk-native-range-no-match]').forEach(function (root) {
      var state = readNativeRangeNoMatchState(root);

      if (state && !seen[state.key]) {
        seen[state.key] = true;
        states.push(state);
      }
    });

    (form.kkNativeRangeNoMatchOrphans || []).forEach(function (state) {
      if (state && state.key && !seen[state.key]) {
        seen[state.key] = true;
        states.push(state);
      }
    });

    return states;
  }

  function serializeNativeRangeNoMatchState(state) {
    return JSON.stringify([state.key, String(state.lower), String(state.upper)]);
  }

  function parseNativeRangeNoMatchState(value) {
    var parsed;
    var lower;
    var upper;

    try {
      parsed = JSON.parse(String(value || ''));
    } catch (error) {
      return null;
    }

    if (
      !Array.isArray(parsed) ||
      parsed.length !== 3 ||
      typeof parsed[0] !== 'string' ||
      parsed[0].indexOf('filter.') !== 0 ||
      parsed[0].length > 220
    ) {
      return null;
    }

    lower = toNumber(parsed[1], NaN);
    upper = toNumber(parsed[2], NaN);

    if (!Number.isFinite(lower) || !Number.isFinite(upper)) {
      return null;
    }

    if (lower > upper) {
      upper = lower;
    }

    return {
      key: parsed[0],
      lower: lower,
      upper: upper
    };
  }

  function getNativeRangeNoMatchStatesFromUrl(urlValue) {
    var url;
    var states = [];
    var seen = {};

    try {
      url = new URL(String(urlValue || window.location.href), window.location.origin);
    } catch (error) {
      return states;
    }

    url.searchParams.getAll(NATIVE_RANGE_NO_MATCH_PARAM).forEach(function (value) {
      var state = parseNativeRangeNoMatchState(value);

      if (!state || seen[state.key]) {
        return;
      }

      seen[state.key] = true;
      states.push(state);
    });

    return states;
  }

  function setNativeRangeNoMatchStatesOnUrl(url, states) {
    url.searchParams.delete(NATIVE_RANGE_NO_MATCH_PARAM);

    (states || []).forEach(function (state) {
      url.searchParams.append(
        NATIVE_RANGE_NO_MATCH_PARAM,
        serializeNativeRangeNoMatchState(state)
      );
    });

    return url;
  }

  function addNativeRangeNoMatchStatesToQuery(query, states) {
    var params = new URLSearchParams(query || '');

    params.delete(NATIVE_RANGE_NO_MATCH_PARAM);
    (states || []).forEach(function (state) {
      params.append(NATIVE_RANGE_NO_MATCH_PARAM, serializeNativeRangeNoMatchState(state));
    });

    return params.toString();
  }

  function applyNativeRangeNoMatchState(root, state) {
    var min;
    var max;
    var lower;
    var upper;
    var lowerSlider;
    var upperSlider;
    var minInput;
    var maxInput;

    if (!root || !state) {
      return null;
    }

    min = toNumber(root.getAttribute('data-kk-range-min'), NaN);
    max = toNumber(root.getAttribute('data-kk-range-max'), NaN);
    if (!Number.isFinite(min) || !Number.isFinite(max) || max < min) {
      return null;
    }

    lower = clamp(toNumber(state.lower, min), min, max);
    upper = clamp(toNumber(state.upper, max), min, max);
    if (lower > upper) {
      upper = lower;
    }

    if (lower <= min && upper >= max) {
      clearNativeRangeNoMatchState(root);
      return null;
    }

    root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
      option.checked = false;
    });

    root.setAttribute('data-kk-native-range-no-match', '');
    root.setAttribute('data-kk-native-range-no-match-lower', String(lower));
    root.setAttribute('data-kk-native-range-no-match-upper', String(upper));

    lowerSlider = root.querySelector('[data-kk-range-lower]');
    upperSlider = root.querySelector('[data-kk-range-upper]');
    minInput = root.querySelector('[data-kk-range-min-input]');
    maxInput = root.querySelector('[data-kk-range-max-input]');

    if (lowerSlider) setFieldValue(lowerSlider, lower);
    if (upperSlider) setFieldValue(upperSlider, upper);
    if (minInput) setFieldValue(minInput, lower);
    if (maxInput) setFieldValue(maxInput, upper);
    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));

    return {
      key: getNativeRangeKey(root),
      lower: lower,
      upper: upper
    };
  }

  function applyNativeRangeNoMatchStatesToForm(form, states) {
    var applied = [];

    if (!form) {
      return applied;
    }

    form.querySelectorAll('[data-kk-native-range]').forEach(clearNativeRangeNoMatchState);
    form.kkNativeRangeNoMatchOrphans = [];

    (states || []).forEach(function (state) {
      var root = findNativeRangeByKey(form, state.key);
      var normalized = applyNativeRangeNoMatchState(root, state);

      if (normalized) {
        applied.push(normalized);
      } else if (!root) {
        if (form) {
          form.kkNativeRangeNoMatchOrphans.push(state);
        }
        applied.push(state);
      }
    });

    return applied;
  }

  function getAvailableNativeRangeOptionKeys(root, state) {
    var matches = new Map();

    if (!root || !state) {
      return matches;
    }

    root.querySelectorAll('[data-kk-native-range-option][name]').forEach(function (option) {
      var value = toNumber(option.getAttribute('data-kk-range-value'), NaN);

      if (
        !option.disabled &&
        Number.isFinite(value) &&
        value >= state.lower &&
        value <= state.upper
      ) {
        matches.set(getFieldKey(option), option);
      }
    });

    return matches;
  }

  function copyMissingNativeRangeOptions(currentRoot, matches) {
    var list = currentRoot && currentRoot.querySelector('.kk-range-filter__options');
    var currentKeys = new Map();

    if (!list || !matches || !matches.size) {
      return;
    }

    currentRoot.querySelectorAll('[data-kk-native-range-option][name]').forEach(function (option) {
      currentKeys.set(getFieldKey(option), true);
    });

    matches.forEach(function (freshOption, key) {
      var freshItem;
      var clone;

      if (currentKeys.has(key) || !freshOption) {
        return;
      }

      freshItem = freshOption.closest && freshOption.closest('li');
      clone = document.importNode(freshItem || freshOption, true);
      list.appendChild(clone);
      currentKeys.set(key, true);
    });
  }

  function resolveNativeRangeNoMatchStates(form, freshForm, states) {
    var converted = [];
    var remaining = [];

    if (form) {
      form.kkNativeRangeNoMatchOrphans = [];
    }

    (states || []).forEach(function (state) {
      var currentRoot = findNativeRangeByKey(form, state.key);
      var freshRoot = findNativeRangeByKey(freshForm, state.key);
      var matches = getAvailableNativeRangeOptionKeys(freshRoot, state);
      var checkedCount = 0;
      var normalized;

      if (currentRoot && matches.size) {
        copyMissingNativeRangeOptions(currentRoot, matches);
        currentRoot.querySelectorAll('[data-kk-native-range-option][name]').forEach(function (option) {
          option.checked = matches.has(getFieldKey(option));
          if (option.checked) {
            checkedCount += 1;
          }
        });

        if (checkedCount) {
          clearNativeRangeNoMatchState(currentRoot);
          syncNativeRangeUi(currentRoot);
          converted.push(state);
          return;
        }
      }

      normalized = applyNativeRangeNoMatchState(currentRoot, state);
      if (normalized) {
        remaining.push(normalized);
      } else if (!currentRoot) {
        // Keep the client-side predicate even when Shopify omits the whole
        // facet from a zero-result response. It can be evaluated again after
        // another query or facet change makes the facet available.
        form.kkNativeRangeNoMatchOrphans.push(state);
        remaining.push(state);
      }
    });

    return {
      converted: converted,
      remaining: remaining
    };
  }

  function isLiveFacetPointerActive(list) {
    return Boolean(list && (liveFacetPointerCounts.get(list) || 0) > 0);
  }

  function getLiveFacetQuerySignature(query) {
    var url;
    var pairs = [];

    if (!query) {
      return '';
    }

    try {
      url = new URL(query, window.location.origin);
      url.searchParams.forEach(function (value, name) {
        pairs.push(JSON.stringify([name, value]));
      });
      pairs.sort();
      return url.pathname + '?' + pairs.join('&');
    } catch (error) {
      return String(query);
    }
  }

  function flushPendingLiveFacetOrder(list) {
    var pending = list && liveFacetPendingOrders.get(list);
    var instance;
    var form;
    var scrollState;

    if (!pending || isLiveFacetPointerActive(list)) {
      return;
    }

    liveFacetPendingOrders.delete(list);
    instance = getDeferredInstance();
    form = list.closest('form');

    if (
      !list.isConnected ||
      !form ||
      !isMobileFilterModalOpen() ||
      (
        pending.expectedQuerySignature &&
        getLiveFacetQuerySignature(buildLiveFacetUrl(instance)) !== pending.expectedQuerySignature
      )
    ) {
      return;
    }

    scrollState = captureLiveFacetScrollState(form);
    applyFacetOptionOrder(list, orderCurrentFacetOptions(list, pending.desiredKeys));
    rebalanceMobileFacetOptions(form);
    restoreLiveFacetScrollState(scrollState);
  }

  function trackLiveFacetPointer(event) {
    var list = event.target && event.target.closest ? event.target.closest('[data-kk-filter-list]') : null;
    var previousList = liveFacetPointerTargets.get(event.pointerId);

    if (!list || !isMobileFilterModalOpen()) {
      return;
    }

    if (previousList && previousList !== list) {
      liveFacetPointerCounts.set(previousList, Math.max(0, (liveFacetPointerCounts.get(previousList) || 1) - 1));
    }

    if (previousList !== list) {
      liveFacetPointerTargets.set(event.pointerId, list);
      liveFacetPointerCounts.set(list, (liveFacetPointerCounts.get(list) || 0) + 1);
    }
  }

  function releaseLiveFacetPointer(event) {
    var list = liveFacetPointerTargets.get(event.pointerId);
    var remaining;

    if (!list) {
      return;
    }

    liveFacetPointerTargets.delete(event.pointerId);
    remaining = Math.max(0, (liveFacetPointerCounts.get(list) || 1) - 1);
    liveFacetPointerCounts.set(list, remaining);

    if (remaining === 0) {
      window.setTimeout(function () {
        flushPendingLiveFacetOrder(list);
      }, 0);
    }
  }
  var staticSearchPatchRetryTimer = null;
  var staticSearchPatchAttempt = 0;
  var STATIC_SEARCH_PATCH_RETRY_DELAY_MS = 100;
  var STATIC_SEARCH_PATCH_MAX_ATTEMPTS = 50;
  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
  var desktopSearchFilterFocusIntent = null;
  var desktopSearchFilterFocusGeneration = 0;
  var DESKTOP_SEARCH_FILTER_FOCUS_TIMEOUT_MS = 15000;
  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

  function isMobile() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function isMobileFilterModalOpen() {
    var modal = document.querySelector('[data-modal-container]');

    return Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible') &&
      isMobile()
    );
  }

  function getDeferredInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (
      activeDeferredInstance &&
      activeDeferredInstance.el &&
      document.body.contains(activeDeferredInstance.el)
    ) {
      return activeDeferredInstance;
    }

    if (!instances) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (window.bcStaticSearch && instance instanceof window.bcStaticSearch) {
        found = instance;
        return true;
      }

      if (window.bcStaticCollection && instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function getFieldKey(field) {
    return field && field.name ? field.name + '\u0000' + (field.value || '') : '';
  }

  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
  function cancelDesktopSearchFilterFocus() {
    var intent = desktopSearchFilterFocusIntent;

    desktopSearchFilterFocusGeneration += 1;
    desktopSearchFilterFocusIntent = null;

    if (intent && intent.expirationTimer !== null) {
      window.clearTimeout(intent.expirationTimer);
    }
  }

  function rememberDesktopSearchFilterFocus(instance, input) {
    var key;
    var generation;
    var intent;

    cancelDesktopSearchFilterFocus();

    if (
      !instance ||
      isMobile() ||
      instance.processing ||
      !input ||
      !input.matches ||
      !input.matches('[data-filter-checkbox][name]') ||
      document.activeElement !== input
    ) {
      return;
    }

    key = getFieldKey(input);
    if (!key) {
      return;
    }

    generation = ++desktopSearchFilterFocusGeneration;
    intent = {
      instance: instance,
      owner: input,
      key: key,
      name: input.name,
      value: input.value || '',
      checked: Boolean(input.checked),
      generation: generation,
      requestStarted: false,
      expiresAt: Date.now() + DESKTOP_SEARCH_FILTER_FOCUS_TIMEOUT_MS,
      expirationTimer: null
    };
    intent.expirationTimer = window.setTimeout(function () {
      if (
        desktopSearchFilterFocusIntent === intent &&
        desktopSearchFilterFocusGeneration === generation
      ) {
        cancelDesktopSearchFilterFocus();
      }
    }, DESKTOP_SEARCH_FILTER_FOCUS_TIMEOUT_MS);
    desktopSearchFilterFocusIntent = intent;
  }

  function markDesktopSearchFilterRequest(instance, fetchUrl) {
    var intent = desktopSearchFilterFocusIntent;
    var url;
    var values;
    var matchesExpectedState;

    if (!intent || intent.instance !== instance) {
      return;
    }

    if (
      intent.requestStarted ||
      !intent.owner ||
      !intent.owner.isConnected ||
      document.activeElement !== intent.owner ||
      (typeof document.hasFocus === 'function' && !document.hasFocus())
    ) {
      cancelDesktopSearchFilterFocus();
      return;
    }

    if (isMobile() || Date.now() > intent.expiresAt) {
      cancelDesktopSearchFilterFocus();
      return;
    }

    try {
      url = new URL(String(fetchUrl || ''), window.location.href);
      values = url.searchParams.getAll(intent.name);
      matchesExpectedState = intent.checked ?
        values.indexOf(intent.value) !== -1 :
        values.indexOf(intent.value) === -1;
    } catch (error) {
      matchesExpectedState = false;
    }

    if (!matchesExpectedState) {
      cancelDesktopSearchFilterFocus();
      return;
    }

    intent.requestStarted = true;
  }

  function isAvailableDesktopSearchFocusTarget(target) {
    var style;

    if (
      !target ||
      !target.isConnected ||
      target.hidden ||
      target.disabled ||
      target.getAttribute('aria-disabled') === 'true' ||
      target.closest('[hidden], [aria-hidden="true"], [inert]')
    ) {
      return false;
    }

    if (window.getComputedStyle) {
      style = window.getComputedStyle(target);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }
    }

    return !target.getClientRects || target.getClientRects().length > 0;
  }

  function findDesktopSearchFilterByKey(instance, key) {
    var selector = instance && instance.filterFormSelector ?
      instance.filterFormSelector :
      '[data-search-filter-form]';
    var form = instance && instance.el && instance.el.querySelector(selector);
    var match = null;

    if (!form) {
      return null;
    }

    Array.prototype.some.call(
      form.querySelectorAll('[data-filter-checkbox][name]'),
      function (input) {
        if (getFieldKey(input) === key) {
          match = input;
          return true;
        }

        return false;
      }
    );

    return match;
  }

  function focusDesktopSearchResultsHeading(instance) {
    var heading = instance && instance.el && instance.el.querySelector('.kk-search-page__title');

    if (!isAvailableDesktopSearchFocusTarget(heading) || typeof heading.focus !== 'function') {
      return;
    }

    if (!heading.hasAttribute('tabindex')) {
      heading.setAttribute('tabindex', '-1');
    }

    heading.focus();
  }

  function queueDesktopSearchFilterFocusRestore(instance) {
    var intent = desktopSearchFilterFocusIntent;
    var generation;

    if (!intent || intent.instance !== instance || !intent.requestStarted) {
      return;
    }

    generation = intent.generation;
    window.requestAnimationFrame(function () {
      var active = document.activeElement;
      var focusIsLost = !active ||
        active === document.body ||
        active === document.documentElement ||
        !active.isConnected;
      var replacement;

      if (
        desktopSearchFilterFocusIntent !== intent ||
        desktopSearchFilterFocusGeneration !== generation ||
        Date.now() > intent.expiresAt ||
        isMobile() ||
        !instance.el ||
        !instance.el.isConnected ||
        (typeof document.hasFocus === 'function' && !document.hasFocus())
      ) {
        cancelDesktopSearchFilterFocus();
        return;
      }

      if (!focusIsLost) {
        cancelDesktopSearchFilterFocus();
        return;
      }

      replacement = findDesktopSearchFilterByKey(instance, intent.key);
      cancelDesktopSearchFilterFocus();

      if (
        replacement &&
        Boolean(replacement.checked) === intent.checked &&
        isAvailableDesktopSearchFocusTarget(replacement) &&
        typeof replacement.focus === 'function'
      ) {
        replacement.focus();
        return;
      }

      focusDesktopSearchResultsHeading(instance);
    });
  }
  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

  function getModalFilterForm(instance) {
    var selector = instance && instance.filterFormSelector ? instance.filterFormSelector : '[data-search-filter-form]';

    return document.querySelector('[data-modal-container].modal--productgrid-filters ' + selector);
  }

  function setLiveFacetBusy(form, busy) {
    if (!form || !form.setAttribute) {
      return;
    }

    if (busy) {
      form.setAttribute('aria-busy', 'true');
    } else {
      form.removeAttribute('aria-busy');
    }
  }

  function getShowResultsLabel(count) {
    var language = String(document.documentElement.lang || '').toLowerCase();

    if (language.indexOf('fi') === 0) {
      return count === 1 ? 'Näytä 1 tulos' : 'Näytä ' + count + ' tulosta';
    }

    if (language.indexOf('sv') === 0) {
      return 'Visa ' + count + ' resultat';
    }

    return count === 1 ? 'Show 1 result' : 'Show ' + count + ' results';
  }

  function getFilterUiScope(form) {
    return form && (
      form.closest('[data-productgrid-filters-content]') ||
      form.closest('[data-modal-content]')
    );
  }

  function getFacetTitle(facet) {
    var title = facet && facet.querySelector('.kk-facet__title');

    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function ensureMobileStagedFilters(form) {
    var root = getFilterUiScope(form);
    var container = root && root.querySelector('[data-kk-mobile-staged-filters]');
    var scroller;
    var nav;

    if (!root) {
      return null;
    }

    if (!container) {
      container = document.createElement('div');
      container.className = 'kk-mobile-staged-filters';
      container.setAttribute('data-kk-mobile-staged-filters', '');
      if (String(document.documentElement.lang || '').toLowerCase().indexOf('fi') === 0) {
        container.setAttribute('aria-label', 'Valitut suodattimet');
      } else if (String(document.documentElement.lang || '').toLowerCase().indexOf('sv') === 0) {
        container.setAttribute('aria-label', 'Valda filter');
      } else {
        container.setAttribute('aria-label', 'Selected filters');
      }
      container.hidden = true;

      scroller = document.createElement('div');
      scroller.className = 'kk-mobile-staged-filters__scroller';
      container.appendChild(scroller);

      nav = form.closest('nav') || root.querySelector('nav');
      (nav ? nav.parentNode : root).insertBefore(container, nav || root.firstChild);
    }

    return container;
  }

  function appendMobileStagedFilter(filters, label, type, facetIndex, name, value) {
    filters.push({
      key: JSON.stringify([type, facetIndex, name || '', value === undefined || value === null ? '' : value]),
      label: label,
      type: type,
      facetIndex: facetIndex,
      name: name || '',
      value: value === undefined || value === null ? '' : value
    });
  }

  function updateMobileStagedFilterButton(button, filter) {
    var language = String(document.documentElement.lang || '').toLowerCase();
    var removeLabel = language.indexOf('fi') === 0 ?
      'Poista suodatin ' :
      (language.indexOf('sv') === 0 ? 'Ta bort filter ' : 'Remove filter ');
    var text = button.querySelector('.kk-mobile-staged-filter__text');
    var remove = button.querySelector('.kk-mobile-staged-filter__remove');

    button.setAttribute('data-kk-staged-key', filter.key);
    button.setAttribute('data-kk-staged-filter-remove', '');
    button.setAttribute('data-kk-remove-type', filter.type);
    button.setAttribute('data-kk-facet-index', String(filter.facetIndex));
    button.setAttribute('aria-label', removeLabel + filter.label);

    if (filter.name) {
      button.setAttribute('data-kk-filter-name', filter.name);
    } else {
      button.removeAttribute('data-kk-filter-name');
    }
    if (filter.value !== '') {
      button.setAttribute('data-kk-filter-value', filter.value);
    } else {
      button.removeAttribute('data-kk-filter-value');
    }

    if (text && text.textContent !== filter.label) {
      text.textContent = filter.label;
    }
    if (remove) {
      remove.setAttribute('aria-hidden', 'true');
    }
  }

  function createMobileStagedFilterButton(filter) {
    var button = document.createElement('button');
    var text = document.createElement('span');
    var remove = document.createElement('span');

    button.type = 'button';
    button.className = 'kk-mobile-staged-filter';
    text.className = 'kk-mobile-staged-filter__text';
    remove.className = 'kk-mobile-staged-filter__remove';
    button.appendChild(text);
    button.appendChild(remove);
    updateMobileStagedFilterButton(button, filter);
    return button;
  }

  function reconcileMobileStagedFilters(scroller, filters) {
    var existing = new Map();

    scroller.querySelectorAll('[data-kk-staged-filter-remove]').forEach(function (button) {
      var key = button.getAttribute('data-kk-staged-key');

      if (!key || existing.has(key)) {
        button.remove();
        return;
      }
      existing.set(key, button);
    });

    filters.forEach(function (filter, index) {
      var button = existing.get(filter.key) || createMobileStagedFilterButton(filter);
      var current = scroller.children[index];

      updateMobileStagedFilterButton(button, filter);
      if (current !== button) {
        scroller.insertBefore(button, current || null);
      }
      existing.delete(filter.key);
    });

    existing.forEach(function (button) {
      button.remove();
    });
  }

  function renderMobileStagedFilters(form) {
    var container;
    var scroller;
    var filters = [];
    var count = 0;

    if (!form || !isMobileFilterModalOpen()) {
      return;
    }

    container = ensureMobileStagedFilters(form);
    scroller = container && container.querySelector('.kk-mobile-staged-filters__scroller');
    if (!scroller) {
      return;
    }

    Array.prototype.forEach.call(form.querySelectorAll('[data-kk-facet]'), function (facet, facetIndex) {
      var title = getFacetTitle(facet);
      var nativeRange = facet.querySelector('[data-kk-native-range]');
      var priceRange = facet.querySelector('[data-kk-price-range]');
      var checked;
      var values;
      var minInput;
      var maxInput;
      var minValue;
      var maxValue;

      if (nativeRange) {
        var noMatchState = readNativeRangeNoMatchState(nativeRange);
        var rangeUnit = nativeRange.getAttribute('data-kk-range-unit') || '';

        checked = Array.prototype.slice.call(
          nativeRange.querySelectorAll('[data-kk-native-range-option]:checked')
        );

        if (noMatchState) {
          appendMobileStagedFilter(
            filters,
            title + ': ' + noMatchState.lower + '–' + noMatchState.upper + (rangeUnit ? ' ' + rangeUnit : ''),
            'native-range',
            facetIndex
          );
          count += 1;
        } else if (checked.length) {
          values = checked.map(function (input) {
            return toNumber(input.getAttribute('data-kk-range-value'), 0);
          }).sort(function (a, b) {
            return a - b;
          });
          appendMobileStagedFilter(
            filters,
            title + ': ' + values[0] + (values.length > 1 ? '–' + values[values.length - 1] : ''),
            'native-range',
            facetIndex
          );
          count += 1;
        }
        return;
      }

      if (priceRange) {
        minInput = priceRange.querySelector('[data-kk-range-min-input]');
        maxInput = priceRange.querySelector('[data-kk-range-max-input]');
        minValue = minInput ? minInput.value.trim() : '';
        maxValue = maxInput ? maxInput.value.trim() : '';

        if (minValue || maxValue) {
          appendMobileStagedFilter(
            filters,
            title + ': ' +
              (minValue || priceRange.getAttribute('data-kk-range-min') || '0') +
              '–' +
              (maxValue || priceRange.getAttribute('data-kk-range-max') || ''),
            'price',
            facetIndex
          );
          count += 1;
        }
        return;
      }

      facet.querySelectorAll('[data-filter-checkbox]:checked').forEach(function (input) {
        var item = input.closest('[data-filter-item]');
        var valueNode = item && item.querySelector('.kk-facet__value');
        var valueLabel = valueNode ? valueNode.textContent.trim() : input.value;

        appendMobileStagedFilter(
          filters,
          title + ': ' + valueLabel,
          'option',
          facetIndex,
          input.name,
          input.value
        );
        count += 1;
      });
    });

    reconcileMobileStagedFilters(scroller, filters);
    container.hidden = count === 0;
    container.setAttribute('data-kk-staged-filter-count', String(count));
  }

  function removeMobileStagedFilter(button) {
    var instance = getDeferredInstance();
    var form = getModalFilterForm(instance);
    var facets = form && form.querySelectorAll('[data-kk-facet]');
    var facetIndex = parseInt(button.getAttribute('data-kk-facet-index'), 10);
    var facet = facets && facets[facetIndex];
    var type = button.getAttribute('data-kk-remove-type');
    var chipIndex = Array.prototype.indexOf.call(
      button.parentNode.querySelectorAll('[data-kk-staged-filter-remove]'),
      button
    );

    if (!instance || !form || !facet) {
      return;
    }

    if (type === 'option') {
      Array.prototype.forEach.call(facet.querySelectorAll('[data-filter-checkbox]'), function (input) {
        var item;

        if (
          input.name !== button.getAttribute('data-kk-filter-name') ||
          input.value !== button.getAttribute('data-kk-filter-value')
        ) {
          return;
        }

        input.checked = false;
        item = input.closest('[data-filter-item]');
        if (item) {
          item.classList.remove('filter-item--active');
          item.classList.add('filter-item--inactive');
        }
      });
    } else if (type === 'native-range') {
      var nativeRangeRoot = facet.querySelector('[data-kk-native-range]');

      facet.querySelectorAll('[data-kk-native-range-option]').forEach(function (input) {
        input.checked = false;
      });
      clearNativeRangeNoMatchState(nativeRangeRoot);
      syncNativeRangeUi(nativeRangeRoot);
    } else if (type === 'price') {
      var priceRoot = facet.querySelector('[data-kk-price-range]');
      var min = toNumber(priceRoot && priceRoot.getAttribute('data-kk-range-min'), 0);
      var max = toNumber(priceRoot && priceRoot.getAttribute('data-kk-range-max'), min);
      var lower = priceRoot && priceRoot.querySelector('[data-kk-range-lower]');
      var upper = priceRoot && priceRoot.querySelector('[data-kk-range-upper]');
      var minField = priceRoot && priceRoot.querySelector('[data-kk-range-min-input]');
      var maxField = priceRoot && priceRoot.querySelector('[data-kk-range-max-input]');

      if (minField) minField.value = '';
      if (maxField) maxField.value = '';
      if (lower) lower.value = String(min);
      if (upper) upper.value = String(max);
      if (priceRoot) priceRoot.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    }

    instance.kkNativeRangeNoMatchStates = collectNativeRangeNoMatchStates(form);
    renderMobileStagedFilters(form);
    markDeferredDirty(instance);

    window.requestAnimationFrame(function () {
      var scope = getFilterUiScope(form);
      var remaining = scope.querySelectorAll(
        '[data-kk-staged-filter-remove]'
      );
      var target = remaining[Math.min(chipIndex, Math.max(remaining.length - 1, 0))] ||
        scope.querySelector('[data-kk-filter-results-button]');

      if (target && typeof target.focus === 'function') {
        target.focus();
      }
    });
  }

  function updateLiveFacetResultCount(form, count) {
    var root = getFilterUiScope(form);
    var button = root && root.querySelector('[data-kk-filter-results-button]');
    var status = root && root.querySelector('[data-kk-live-facet-status]');
    var buttonLabel;

    if (!Number.isFinite(count) || count < 0 || !root) {
      return;
    }

    root.setAttribute('data-kk-live-result-count', String(count));
    root.removeAttribute('data-kk-live-facets-stale');

    if (button) {
      button.setAttribute('data-kk-result-count', String(count));
      button.textContent = getShowResultsLabel(count);
    }

    if (status) {
      buttonLabel = button ? button.textContent.trim() : '';
      status.textContent = buttonLabel || String(count);
    }
  }

  function getLiveFacetMessage(type, count) {
    var isFinnish = String(document.documentElement.lang || '').toLowerCase().indexOf('fi') === 0;

    if (type === 'rollback') {
      return isFinnish ?
        'Tällä yhdistelmällä ei ole tuotteita. Viimeisin valinta poistettiin. ' + count + ' tulosta.' :
        'No products match this combination. The latest selection was removed. ' + count + ' results.';
    }

    if (type === 'limit') {
      return isFinnish ?
        'Suodatinvaihtoehtoja ei voida päivittää tälle tulosmäärälle.' :
        'Filter options cannot be updated for this number of results.';
    }

    return isFinnish ?
      'Suodatinvaihtoehtoja ei voitu päivittää. Voit silti näyttää tulokset.' :
      'Filter options could not be updated. You can still show the results.';
  }

  function announceLiveFacetState(form, type, count) {
    var root = getFilterUiScope(form);
    var status = root && root.querySelector('[data-kk-live-facet-status]');

    if (status) {
      status.textContent = getLiveFacetMessage(type, count);
    }
  }

  function markLiveFacetStateStale(form, reason) {
    var root = getFilterUiScope(form);
    var status = root && root.querySelector('[data-kk-live-facet-status]');

    if (root) {
      root.setAttribute('data-kk-live-facets-stale', 'true');
    }

    if (status) {
      status.textContent = getLiveFacetMessage(reason === 'limit' ? 'limit' : 'error');
    }
  }

  function setOptionDisabled(input, disabled) {
    var item = input && input.closest('[data-filter-item]');
    var label = item && item.querySelector('[data-filter-label], .filter-item__label');
    var facet = input && input.closest('[data-kk-facet]');
    var focusTarget = null;

    if (!input) {
      return;
    }

    if (disabled && document.activeElement === input && facet) {
      focusTarget = Array.prototype.find.call(
        facet.querySelectorAll('[data-filter-checkbox]:not(:disabled)'),
        function (candidate) { return candidate !== input; }
      ) || facet.querySelector('summary');
    }

    input.disabled = Boolean(disabled);

    if (item) {
      item.classList.toggle('filter-item--disabled', Boolean(disabled));
      item.classList.toggle('filter-item--active', Boolean(input.checked));
      item.classList.toggle('filter-item--inactive', !input.checked);
    }

    if (label) {
      label.classList.toggle('filter-item__label--disabled', Boolean(disabled));
    }

    if (focusTarget && typeof focusTarget.focus === 'function') {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (error) {
        focusTarget.focus();
      }
    }
  }

  function rebalanceMobileFacetOptions(form) {
    if (!form || !isMobile() || !form.closest('[data-modal-container].modal--productgrid-filters')) {
      return;
    }

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var facet = list.closest('[data-kk-facet]');
      var search = facet && facet.querySelector('[data-kk-filter-search]');
      var term = search ? search.value.trim() : '';
      var toggle = list.querySelector('[data-filter-toggle]');
      var toggleItem = toggle && toggle.closest('.filter-item');
      var limit = parseInt(list.getAttribute('data-kk-mobile-filter-limit'), 10) || 5;
      var options = Array.prototype.slice.call(list.querySelectorAll('[data-kk-filter-option]'));
      var eligible = [];
      var defaultVisible = new Set();
      var expanded = Boolean(toggle && toggle.getAttribute('data-filter-toggle') === 'true');
      var hasOverflow;

      rememberMobileFacetOptionOrder(list);

      options.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        var selected = Boolean(input && input.checked);

        if (!input || (!selected && input.disabled)) {
          return;
        }

        eligible.push(item);
        if (selected) {
          defaultVisible.add(item);
        }
      });

      eligible.forEach(function (item) {
        if (defaultVisible.size < limit) {
          defaultVisible.add(item);
        }
      });

      options.forEach(function (item) {
        var input = item.querySelector('[data-filter-checkbox]');
        var usable = Boolean(input && (input.checked || !input.disabled));
        var hiddenByDefault = usable && !defaultVisible.has(item);

        if (!item.hasAttribute('data-kk-desktop-hidden-default')) {
          item.setAttribute(
            'data-kk-desktop-hidden-default',
            item.hasAttribute('data-hidden-default') ? 'true' : 'false'
          );
        }

        item.toggleAttribute('data-hidden-default', hiddenByDefault);

        if (!term) {
          item.classList.toggle('filter-item--hidden', hiddenByDefault && expanded === false);
        }
      });

      hasOverflow = eligible.some(function (item) {
        return !defaultVisible.has(item);
      });

      if (!hasOverflow && toggle) {
        expanded = false;
        toggle.setAttribute('data-filter-toggle', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent =
          toggle.getAttribute('data-kk-see-more-text') ||
          (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
          'See more';
        list.classList.remove('kk-facet__list--expanded');
      }

      if (toggleItem) {
        toggleItem.toggleAttribute('data-kk-no-eligible-overflow', !hasOverflow);
        toggleItem.hidden = Boolean(term) || !hasOverflow;
      }
    });
  }

  function restoreDesktopFacetOptions() {
    if (isMobile()) {
      return;
    }

    document.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var options = list.querySelectorAll('[data-kk-filter-option][data-kk-desktop-hidden-default]');
      var originalOrder = getDirectFacetOptions(list);
      var toggle = list.querySelector('[data-filter-toggle]');
      var toggleItem = toggle && toggle.closest('.filter-item');
      var facet = list.closest('[data-kk-facet]');
      var search = facet && facet.querySelector('[data-kk-filter-search]');

      if (originalOrder.some(function (item) {
        return item.hasAttribute('data-kk-mobile-original-order');
      })) {
        originalOrder.sort(function (a, b) {
          var aIndex = parseInt(a.getAttribute('data-kk-mobile-original-order'), 10);
          var bIndex = parseInt(b.getAttribute('data-kk-mobile-original-order'), 10);
          return (Number.isFinite(aIndex) ? aIndex : Number.MAX_SAFE_INTEGER) -
            (Number.isFinite(bIndex) ? bIndex : Number.MAX_SAFE_INTEGER);
        });
        applyFacetOptionOrder(list, originalOrder);
      }

      if (!options.length) {
        return;
      }

      options.forEach(function (item) {
        var hiddenByDefault = item.getAttribute('data-kk-desktop-hidden-default') === 'true';

        item.toggleAttribute('data-hidden-default', hiddenByDefault);
        item.classList.toggle('filter-item--hidden', hiddenByDefault);
        item.classList.remove('kk-filter-option--search-hidden');
        item.hidden = false;
        item.removeAttribute('data-kk-desktop-hidden-default');
        item.removeAttribute('data-kk-mobile-original-order');
      });

      if (search) {
        search.value = '';
      }

      list.classList.remove('kk-facet__list--expanded');

      if (toggle) {
        toggle.setAttribute('data-filter-toggle', 'false');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent =
          toggle.getAttribute('data-kk-see-more-text') ||
          (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
          'See more';
      }

      if (toggleItem) {
        toggleItem.hidden = false;
        toggleItem.removeAttribute('data-kk-no-eligible-overflow');
        toggleItem.classList.remove('kk-filter-option--search-hidden');
      }
    });
  }

  function syncFacetOptionsForBreakpoint() {
    var instance;
    var form;
    var scrollState;

    if (!isMobile()) {
      restoreDesktopFacetOptions();
      return;
    }

    if (isMobileFilterModalOpen()) {
      instance = getDeferredInstance();
      form = getModalFilterForm(instance);
      scrollState = captureLiveFacetScrollState(form);
      applyLatestLiveFacetOrders(form);
      rebalanceMobileFacetOptions(form);
      restoreLiveFacetScrollState(scrollState);
    }
  }

  function getOptionCountNode(input) {
    var item = input && input.closest('[data-filter-item]');
    return item ? item.querySelector('.kk-facet__count') : null;
  }

  function buildFreshOptionMap(freshForm) {
    var map = new Map();

    if (!freshForm) {
      return map;
    }

    freshForm.querySelectorAll('[data-filter-checkbox][name]').forEach(function (input) {
      var key = getFieldKey(input);
      if (key) {
        map.set(key, input);
      }
    });

    return map;
  }

  function getFacetParamName(input) {
    var facet = input && input.closest('[data-kk-facet]');
    var firstInput = facet && facet.querySelector('[data-filter-checkbox][name]');
    return firstInput ? firstInput.name : '';
  }

  function buildFreshFacetGroupMap(freshForm) {
    var groups = new Map();

    if (!freshForm) {
      return groups;
    }

    freshForm.querySelectorAll('[data-kk-facet]').forEach(function (facet) {
      var options = facet.querySelectorAll('[data-filter-checkbox][name]');
      var name = options[0] ? options[0].name : '';

      if (name) {
        groups.set(name, options.length);
      }
    });

    return groups;
  }

  function getDirectFacetOptions(list) {
    return Array.prototype.filter.call(list ? list.children : [], function (item) {
      return item.matches && item.matches('[data-kk-filter-option]');
    });
  }

  function rememberMobileFacetOptionOrder(list) {
    getDirectFacetOptions(list).forEach(function (item, index) {
      if (!item.hasAttribute('data-kk-mobile-original-order')) {
        item.setAttribute('data-kk-mobile-original-order', String(index));
      }
    });
  }

  function buildFreshFacetOrderMap(freshForm) {
    var orders = new Map();

    if (!freshForm) {
      return orders;
    }

    freshForm.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var inputs = list.querySelectorAll('[data-kk-filter-option] [data-filter-checkbox][name]');
      var name = inputs[0] ? inputs[0].name : '';
      var keys = [];

      inputs.forEach(function (input) {
        var key = getFieldKey(input);
        if (key) {
          keys.push(key);
        }
      });

      if (name) {
        orders.set(name, keys);
      }
    });

    return orders;
  }

  function orderCurrentFacetOptions(list, desiredKeys) {
    var options = getDirectFacetOptions(list);
    var optionsByKey = new Map();
    var included = new Set();
    var ordered = [];

    options.forEach(function (item) {
      var input = item.querySelector('[data-filter-checkbox][name]');
      var key = getFieldKey(input);
      if (key && !optionsByKey.has(key)) {
        optionsByKey.set(key, item);
      }
    });

    desiredKeys.forEach(function (key) {
      var item = optionsByKey.get(key);
      if (item && !included.has(item)) {
        ordered.push(item);
        included.add(item);
      }
    });

    options.forEach(function (item) {
      if (!included.has(item)) {
        ordered.push(item);
      }
    });

    return ordered;
  }

  function applyFacetOptionOrder(list, orderedOptions) {
    var nonOptions = Array.prototype.filter.call(list.children, function (item) {
      return !item.matches || !item.matches('[data-kk-filter-option]');
    });
    var orderedChildren = orderedOptions.concat(nonOptions);
    var currentChildren = Array.prototype.slice.call(list.children);
    var changed = currentChildren.length !== orderedChildren.length || orderedChildren.some(function (item, index) {
      return currentChildren[index] !== item;
    });
    var activeElement;
    var activeChild;
    var activeIndex;
    var beforeFragment;
    var afterFragment;

    if (!changed) {
      return false;
    }

    activeElement = document.activeElement;
    activeChild = activeElement && list.contains(activeElement) && activeElement.closest ?
      activeElement.closest('[data-kk-filter-option], .filter-item--toggle-more') :
      null;
    activeIndex = activeChild && activeChild.parentNode === list ? orderedChildren.indexOf(activeChild) : -1;

    if (activeIndex !== -1) {
      beforeFragment = document.createDocumentFragment();
      afterFragment = document.createDocumentFragment();
      orderedChildren.slice(0, activeIndex).forEach(function (item) {
        beforeFragment.appendChild(item);
      });
      orderedChildren.slice(activeIndex + 1).forEach(function (item) {
        afterFragment.appendChild(item);
      });
      list.insertBefore(beforeFragment, activeChild);
      list.insertBefore(afterFragment, activeChild.nextSibling);
    } else if (typeof list.replaceChildren === 'function') {
      list.replaceChildren.apply(list, orderedChildren);
    } else {
      orderedChildren.forEach(function (item) {
        list.appendChild(item);
      });
    }

    return true;
  }

  function captureLiveFacetScrollState(form) {
    var modalInner = form && (form.closest('.modal-inner') || form.closest('[data-modal-inner]'));
    var lists = [];

    if (form) {
      form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
        lists.push({ element: list, scrollTop: list.scrollTop });
      });
    }

    return {
      modalInner: modalInner,
      modalScrollTop: modalInner ? modalInner.scrollTop : 0,
      lists: lists
    };
  }

  function restoreLiveFacetScrollState(state) {
    if (!state) {
      return;
    }

    state.lists.forEach(function (entry) {
      if (entry.element && entry.element.isConnected) {
        entry.element.scrollTop = entry.scrollTop;
      }
    });

    if (state.modalInner && state.modalInner.isConnected) {
      state.modalInner.scrollTop = state.modalScrollTop;
    }
  }

  function reorderLiveFacetOptions(form, freshForm, expectedQuery) {
    var orders = buildFreshFacetOrderMap(freshForm);
    var querySignature = getLiveFacetQuerySignature(
      expectedQuery || buildLiveFacetUrl(getDeferredInstance())
    );

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var firstInput = list.querySelector('[data-filter-checkbox][name]');
      var desiredKeys = firstInput ? orders.get(firstInput.name) : null;

      if (!desiredKeys) {
        return;
      }

      rememberMobileFacetOptionOrder(list);
      liveFacetLatestOrders.set(list, desiredKeys.slice());

      if (isLiveFacetPointerActive(list)) {
        liveFacetPendingOrders.set(list, {
          desiredKeys: desiredKeys.slice(),
          expectedQuerySignature: querySignature
        });
        return;
      }

      liveFacetPendingOrders.delete(list);
      applyFacetOptionOrder(list, orderCurrentFacetOptions(list, desiredKeys));
    });
  }

  function applyLatestLiveFacetOrders(form) {
    if (!form) {
      return;
    }

    form.querySelectorAll('[data-kk-filter-list]').forEach(function (list) {
      var desiredKeys = liveFacetLatestOrders.get(list);

      if (!desiredKeys) {
        return;
      }

      rememberMobileFacetOptionOrder(list);
      applyFacetOptionOrder(list, orderCurrentFacetOptions(list, desiredKeys));
    });
  }

  function reconcileLiveFacetOptions(form, freshForm, zeroResults, expectedQuery) {
    var freshOptions = buildFreshOptionMap(freshForm);
    var freshGroups = buildFreshFacetGroupMap(freshForm);
    var scrollState = captureLiveFacetScrollState(form);

    if (freshForm) {
      reorderLiveFacetOptions(form, freshForm, expectedQuery || '');
    }

    form.querySelectorAll('[data-filter-checkbox][name]').forEach(function (input) {
      var freshInput = freshOptions.get(getFieldKey(input));
      var freshCount = getOptionCountNode(freshInput);
      var liveCount = getOptionCountNode(input);
      var facetParamName = getFacetParamName(input);
      var freshGroupSize = freshGroups.get(facetParamName);
      var disabled;

      if (freshInput) {
        disabled = !input.checked && freshInput.disabled;
        if (liveCount && freshCount) {
          liveCount.textContent = freshCount.textContent;
        }
        setOptionDisabled(input, disabled);
        return;
      }

      if (zeroResults) {
        if (liveCount) {
          liveCount.textContent = '(0)';
        }
        setOptionDisabled(input, !input.checked);
        return;
      }

      if (!input.checked && freshGroupSize > 0 && freshGroupSize < 100) {
        if (liveCount) {
          liveCount.textContent = '(0)';
        }
        setOptionDisabled(input, true);
      }
    });

    rebalanceMobileFacetOptions(form);
    restoreLiveFacetScrollState(scrollState);
  }

  function captureLiveFacetSelection(form) {
    var state = new Map();

    if (!form) {
      return state;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      var key;

      if (!field || !field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        key = getFieldKey(field);
        state.set(key, {
          checked: Boolean(field.checked),
          type: field.type
        });
      } else {
        key = field.name + '\u0000__field';
        state.set(key, {
          value: field.value,
          type: field.type
        });
      }
    });

    form.querySelectorAll('[data-kk-native-range]').forEach(function (root) {
      var key = getNativeRangeKey(root);

      if (key) {
        state.set('__kk_native_range_no_match__\u0000' + key, {
          noMatch: readNativeRangeNoMatchState(root)
        });
      }
    });

    return state;
  }

  function restoreLiveFacetSelection(form, state) {
    if (!form || !state) {
      return;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      var key;
      var saved;

      if (!field || !field.name) {
        return;
      }

      key = field.type === 'checkbox' || field.type === 'radio' ?
        getFieldKey(field) :
        field.name + '\u0000__field';
      saved = state.get(key);

      if (!saved) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Boolean(saved.checked);
      } else {
        field.value = saved.value;
      }
    });

    form.querySelectorAll('[data-kk-native-range]').forEach(function (root) {
      var key = getNativeRangeKey(root);
      var saved = key && state.get('__kk_native_range_no_match__\u0000' + key);

      if (saved && saved.noMatch) {
        applyNativeRangeNoMatchState(root, saved.noMatch);
      } else {
        clearNativeRangeNoMatchState(root);
      }
    });

    syncDeferredRangeUi(form);

    // syncDeferredRangeUi intentionally paints the range thumbs, but price fields
    // at their default extrema must remain empty so they are not submitted.
    Array.prototype.forEach.call(form.elements, function (field) {
      var saved;

      if (!field || !field.name || field.type === 'checkbox' || field.type === 'radio') {
        return;
      }

      saved = state.get(field.name + '\u0000__field');
      if (saved) {
        field.value = saved.value;
      }
    });
  }

  function rememberLastValidLiveFacetState(form, count, freshForm) {
    if (!form || !Number.isFinite(count) || count < 1) {
      return;
    }

    liveFacetLastValidSelection = captureLiveFacetSelection(form);
    liveFacetLastValidForm = (freshForm || form).cloneNode(true);
    liveFacetLastValidCount = count;
  }

  function captureInitialLiveFacetState(instance, preferredForm) {
    var sourceForm;
    var results;
    var count;

    if (liveFacetLastValidSelection || !instance || !instance.el) {
      return;
    }

    sourceForm = preferredForm ||
      getModalFilterForm(instance) ||
      instance.el.querySelector(instance.filterFormSelector || '[data-search-filter-form]');
    results = instance.el.querySelector('[data-results-container]');
    count = Number.isFinite(liveFacetLastValidCount) ?
      liveFacetLastValidCount :
      parseInt(results && results.getAttribute('data-product-count'), 10);

    if (sourceForm && Number.isFinite(count) && count > 0) {
      rememberLastValidLiveFacetState(sourceForm, count);
    }
  }

  function primeLiveFacetSession(instance) {
    var form;
    var results;
    var count;

    if (!isMobileFilterModalOpen()) {
      return;
    }

    instance = instance || getDeferredInstance();
    form = getModalFilterForm(instance);

    if (!instance || !form) {
      return;
    }

    if (!liveFacetSessionOpen) {
      liveFacetSessionOpen = true;
      liveFacetSessionId += 1;
    }

    rebalanceMobileFacetOptions(form);
    captureInitialLiveFacetState(instance, form);
    results = instance.el.querySelector('[data-results-container]');
    count = parseInt(results && results.getAttribute('data-product-count'), 10);
    if (Number.isFinite(count) && count >= 0) {
      updateLiveFacetResultCount(form, count);
    }
    renderMobileStagedFilters(form);
  }

  function restoreLastValidLiveFacetState(form) {
    if (!form || !liveFacetLastValidSelection || !liveFacetLastValidForm) {
      return false;
    }

    restoreLiveFacetSelection(form, liveFacetLastValidSelection);
    reconcileLiveFacetOptions(form, liveFacetLastValidForm, false);
    reconcileNativeRanges(form, liveFacetLastValidForm);
    repaintNativeRanges(form);
    updateLiveFacetResultCount(form, liveFacetLastValidCount);
    renderMobileStagedFilters(form);
    announceLiveFacetState(form, 'rollback', liveFacetLastValidCount);
    return true;
  }

  function reconcileNativeRanges(form, freshForm) {
    var freshRanges = new Map();

    if (!form || !freshForm) {
      return;
    }

    freshForm.querySelectorAll('[data-kk-native-range]').forEach(function (range) {
      var option = range.querySelector('[data-kk-native-range-option][name]');

      if (option) {
        freshRanges.set(option.name, range);
      }
    });

    form.querySelectorAll('[data-kk-native-range]').forEach(function (current) {
      var option = current.querySelector('[data-kk-native-range-option][name]');
      var fresh = option && freshRanges.get(option.name);
      var newMin;
      var newMax;
      var bounds;
      var freshBounds;
      var unit;

      if (!fresh) {
        return;
      }

      newMin = toNumber(fresh.dataset.kkRangeMin, NaN);
      newMax = toNumber(fresh.dataset.kkRangeMax, NaN);

      if (!Number.isFinite(newMin) || !Number.isFinite(newMax) || newMax < newMin) {
        return;
      }

      current.dataset.kkRangeMin = String(newMin);
      current.dataset.kkRangeMax = String(newMax);

      current.querySelectorAll(
        '[data-kk-range-min-input], [data-kk-range-max-input], [data-kk-range-lower], [data-kk-range-upper]'
      ).forEach(function (input) {
        input.setAttribute('min', String(newMin));
        input.setAttribute('max', String(newMax));
      });

      current.querySelectorAll('[data-kk-native-range-option]').forEach(function (input) {
        var value = toNumber(input.dataset.kkRangeValue, NaN);

        // An active value outside the new contextual domain cannot contribute
        // to the preview result. Drop it so the staged form, fields and chips
        // all describe the same effective range.
        if (input.checked && Number.isFinite(value) && (value < newMin || value > newMax)) {
          input.checked = false;
        }
      });

      bounds = current.querySelectorAll('.kk-range-filter__bounds span');
      freshBounds = fresh.querySelectorAll('.kk-range-filter__bounds span');
      unit = current.getAttribute('data-kk-range-unit') || '';
      if (bounds[0]) bounds[0].textContent = freshBounds[0] ? freshBounds[0].textContent : String(newMin) + (unit ? ' ' + unit : '');
      if (bounds[1]) bounds[1].textContent = freshBounds[1] ? freshBounds[1].textContent : String(newMax) + (unit ? ' ' + unit : '');

      syncNativeRangeUi(current);
    });
  }

  function reconcilePriceRange(form, freshForm) {
    var current = form.querySelector('[data-kk-price-range]');
    var fresh = freshForm && freshForm.querySelector('[data-kk-price-range]');
    var minInput;
    var maxInput;
    var lower;
    var upper;
    var bounds;
    var freshBounds;
    var newMin;
    var newMax;
    var oldMin;
    var oldMax;
    var currentLower;
    var currentUpper;
    var explicitMin;
    var explicitMax;

    if (!current || !fresh) {
      return;
    }

    newMin = toNumber(fresh.dataset.kkRangeMin, NaN);
    newMax = toNumber(fresh.dataset.kkRangeMax, NaN);

    if (!Number.isFinite(newMin) || !Number.isFinite(newMax) || newMax < newMin) {
      return;
    }

    oldMin = toNumber(current.dataset.kkRangeMin, newMin);
    oldMax = toNumber(current.dataset.kkRangeMax, newMax);
    minInput = current.querySelector('[data-kk-range-min-input]');
    maxInput = current.querySelector('[data-kk-range-max-input]');
    lower = current.querySelector('[data-kk-range-lower]');
    upper = current.querySelector('[data-kk-range-upper]');
    explicitMin = Boolean(minInput && minInput.value !== '');
    explicitMax = Boolean(maxInput && maxInput.value !== '');

    // Never rewrite a staged explicit price query from a preview response. The
    // displayed count must describe exactly the query that X/Show results applies.
    if (explicitMin || explicitMax) {
      return;
    }

    currentLower = clamp(toNumber(lower && lower.value, oldMin), newMin, newMax);
    currentUpper = clamp(toNumber(upper && upper.value, oldMax), newMin, newMax);

    if (!explicitMin) {
      currentLower = newMin;
    }
    if (!explicitMax) {
      currentUpper = newMax;
    }
    if (currentLower > currentUpper) {
      if (explicitMin && !explicitMax) {
        currentUpper = currentLower;
      } else {
        currentLower = currentUpper;
      }
    }

    current.dataset.kkRangeMin = String(newMin);
    current.dataset.kkRangeMax = String(newMax);

    [minInput, maxInput, lower, upper].forEach(function (input) {
      if (!input) return;
      input.setAttribute('min', String(newMin));
      input.setAttribute('max', String(newMax));
    });

    if (maxInput) {
      maxInput.placeholder = String(newMax);
      maxInput.setAttribute('placeholder', String(newMax));
    }

    if (lower) setFieldValue(lower, currentLower);
    if (upper) setFieldValue(upper, currentUpper);
    if (explicitMin && minInput) setFieldValue(minInput, currentLower);
    if (explicitMax && maxInput) setFieldValue(maxInput, currentUpper);

    bounds = current.querySelectorAll('.kk-range-filter__bounds span');
    freshBounds = fresh.querySelectorAll('.kk-range-filter__bounds span');
    if (bounds[0] && freshBounds[0]) bounds[0].textContent = freshBounds[0].textContent;
    if (bounds[1] && freshBounds[1]) bounds[1].textContent = freshBounds[1].textContent;

    current.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function repaintNativeRanges(form) {
    form.querySelectorAll('[data-kk-native-range]').forEach(function (range) {
      range.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
    });
  }

  function applyLiveFacetMarkup(instance, markup, expectedQuery, requestId, sessionId) {
    var doc;
    var preview;
    var filterCount;
    var resultCount;
    var freshForm;
    var noMatchStates;
    var resolution;
    var form = getModalFilterForm(instance);

    if (
      requestId !== liveFacetRequestId ||
      sessionId !== liveFacetSessionId ||
      !isMobileFilterModalOpen() ||
      !form ||
      form !== liveFacetActiveForm ||
      buildLiveFacetUrl(instance) !== expectedQuery
    ) {
      return false;
    }

    try {
      doc = new DOMParser().parseFromString(markup, 'text/html');
    } catch (error) {
      return false;
    }

    preview = doc.querySelector('[data-kk-search-facet-preview]');
    if (!preview) {
      return false;
    }

    filterCount = parseInt(preview.getAttribute('data-kk-filter-count'), 10);
    resultCount = parseInt(preview.getAttribute('data-kk-search-count'), 10);

    if (!Number.isFinite(filterCount) || !Number.isFinite(resultCount)) {
      return false;
    }

    freshForm = preview.querySelector('[data-search-filter-form]');
    if (!freshForm) {
      markLiveFacetStateStale(form);
      return false;
    }

    noMatchStates = collectNativeRangeNoMatchStates(form);
    if (noMatchStates.length) {
      resolution = resolveNativeRangeNoMatchStates(form, freshForm, noMatchStates);
      instance.kkNativeRangeNoMatchStates = resolution.remaining;

      reconcileLiveFacetOptions(form, freshForm, false, expectedQuery);
      reconcileNativeRanges(form, freshForm);
      reconcilePriceRange(form, freshForm);
      repaintNativeRanges(form);
      updateLiveFacetResultCount(form, 0);
      renderMobileStagedFilters(form);

      if (getFilterUiScope(form)) {
        getFilterUiScope(form).setAttribute('data-kk-live-facets-query', expectedQuery);
      }

      if (resolution.converted.length) {
        // The marker was stale: the current query now exposes exact Shopify
        // values inside the range. Convert it to real checkbox parameters and
        // immediately preview that canonical query.
        window.setTimeout(function () {
          queueLiveFacetRefresh(instance);
        }, 0);
        return false;
      }

      document.dispatchEvent(new CustomEvent('kk:search-live-facets-updated', {
        detail: {
          count: 0,
          url: expectedQuery
        }
      }));
      return true;
    }

    if (resultCount === 0) {
      if (!restoreLastValidLiveFacetState(form)) {
        reconcileLiveFacetOptions(form, null, true);
        repaintNativeRanges(form);
      }
      return false;
    }

    if (filterCount < 1) {
      markLiveFacetStateStale(form, 'limit');
      return false;
    }

    updateLiveFacetResultCount(form, resultCount);
    reconcileLiveFacetOptions(form, freshForm, false, expectedQuery);
    reconcileNativeRanges(form, freshForm);
    reconcilePriceRange(form, freshForm);
    repaintNativeRanges(form);
    renderMobileStagedFilters(form);
    if (getFilterUiScope(form)) {
      getFilterUiScope(form).setAttribute('data-kk-live-facets-query', expectedQuery);
    }
    rememberLastValidLiveFacetState(form, resultCount, freshForm);
    document.dispatchEvent(new CustomEvent('kk:search-live-facets-updated', {
      detail: {
        count: resultCount,
        url: expectedQuery
      }
    }));

    return true;
  }

  function rememberLiveFacetMarkup(query, markup) {
    if (liveFacetCache.has(query)) {
      liveFacetCache.set(query, markup);
      return;
    }

    liveFacetCache.set(query, markup);
    liveFacetCacheOrder.push(query);

    while (liveFacetCacheOrder.length > LIVE_FACET_CACHE_LIMIT) {
      liveFacetCache.delete(liveFacetCacheOrder.shift());
    }
  }

  function buildLiveFacetUrl(instance) {
    var fetchUrl = buildDeferredSearchFetchUrl(instance);
    var url;

    if (!fetchUrl) {
      return '';
    }

    try {
      url = new URL(fetchUrl, window.location.origin);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.set('view', 'kk-facets');
    return url.pathname + url.search;
  }

  function finishLiveFacetRequest(form, requestId, sessionId) {
    if (requestId !== liveFacetRequestId || sessionId !== liveFacetSessionId) {
      return;
    }

    liveFacetController = null;
    liveFacetActiveQuery = '';
    setLiveFacetBusy(form, false);
  }

  function startLiveFacetRequest(instance, query, requestId, sessionId, form) {
    var cachedMarkup = liveFacetCache.get(query);

    if (cachedMarkup) {
      applyLiveFacetMarkup(instance, cachedMarkup, query, requestId, sessionId);
      finishLiveFacetRequest(form, requestId, sessionId);
      return;
    }

    liveFacetController = new AbortController();

    fetch(kkStripNativeRangeNoMatchRequestParam(query), {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      signal: liveFacetController.signal
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Live facet request failed');
      }
      return response.text();
    }).then(function (markup) {
      var applied;

      if (requestId !== liveFacetRequestId || sessionId !== liveFacetSessionId) {
        return;
      }

      applied = applyLiveFacetMarkup(instance, markup, query, requestId, sessionId);
      if (applied) {
        rememberLiveFacetMarkup(query, markup);
      }
    }).catch(function (error) {
      if (error && error.name === 'AbortError') {
        return;
      }

      if (requestId === liveFacetRequestId && sessionId === liveFacetSessionId) {
        markLiveFacetStateStale(form, 'error');
      }
    }).then(function () {
      finishLiveFacetRequest(form, requestId, sessionId);
    });
  }

  function queueLiveFacetRefresh(instance) {
    var form;
    var query;
    var requestId;
    var sessionId;

    if (!instance || !isMobileFilterModalOpen()) {
      return;
    }

    form = getModalFilterForm(instance);
    if (!form || !form.querySelector('[data-kk-facet]')) {
      return;
    }

    query = buildLiveFacetUrl(instance);
    if (!query) {
      return;
    }

    if (liveFacetActiveQuery === query && (liveFacetTimer || liveFacetController)) {
      return;
    }

    primeLiveFacetSession(instance);

    window.clearTimeout(liveFacetTimer);
    liveFacetTimer = null;

    if (liveFacetController) {
      liveFacetController.abort();
      liveFacetController = null;
    }

    liveFacetRequestId += 1;
    requestId = liveFacetRequestId;
    sessionId = liveFacetSessionId;
    liveFacetActiveQuery = query;
    liveFacetActiveForm = form;
    setLiveFacetBusy(form, true);

    liveFacetTimer = window.setTimeout(function () {
      liveFacetTimer = null;
      startLiveFacetRequest(instance, query, requestId, sessionId, form);
    }, LIVE_FACET_DEBOUNCE_MS);
  }

  function cancelLiveFacetRefresh() {
    window.clearTimeout(liveFacetTimer);
    liveFacetTimer = null;
    liveFacetRequestId += 1;
    liveFacetSessionId += 1;
    liveFacetSessionOpen = false;
    liveFacetActiveQuery = '';
    liveFacetLastValidSelection = null;
    liveFacetLastValidForm = null;
    liveFacetLastValidCount = null;
    liveFacetPointerTargets.clear();
    liveFacetPointerCounts = new WeakMap();
    liveFacetPendingOrders = new WeakMap();
    liveFacetLatestOrders = new WeakMap();

    if (liveFacetController) {
      liveFacetController.abort();
      liveFacetController = null;
    }

    setLiveFacetBusy(liveFacetActiveForm, false);
    liveFacetActiveForm = null;
  }

  function syncPriceRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var lowerValue = clamp(toNumber(minInput && minInput.value, min), min, max);
    var upperValue = clamp(toNumber(maxInput && maxInput.value, max), min, max);

    if (lowerValue > upperValue) {
      upperValue = lowerValue;
    }

    if (lower) lower.value = lowerValue;
    if (upper) upper.value = upperValue;
    setFieldValue(minInput, lowerValue);
    setFieldValue(maxInput, upperValue);
    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function syncNativeRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var values = [];
    var noMatchState = readNativeRangeNoMatchState(root);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
      if (option.checked) {
        values.push(toNumber(option.dataset.kkRangeValue, min));
      }
    });

    if (!values.length && noMatchState) {
      values = [
        clamp(noMatchState.lower, min, max),
        clamp(noMatchState.upper, min, max)
      ];
    } else if (!values.length) {
      values = [min, max];
    }

    values.sort(function (a, b) {
      return a - b;
    });

    if (lower) lower.value = values[0];
    if (upper) upper.value = values[values.length - 1];
    setFieldValue(minInput, values[0]);
    setFieldValue(maxInput, values[values.length - 1]);
    root.dispatchEvent(new Event('kk:sync-native-range-ui', { bubbles: true }));
  }

  function syncDeferredRangeUi(form) {
    form.querySelectorAll('[data-kk-price-range]').forEach(syncPriceRangeUi);
    form.querySelectorAll('[data-kk-native-range]').forEach(syncNativeRangeUi);
  }

  function getQueryStringFromHref(href) {
    try {
      return new URL(href || '', window.location.origin).search.replace(/^\?/, '');
    } catch (error) {
      return '';
    }
  }

  function applyQueryToFilterForm(queryString) {
    var form = document.querySelector('[data-filter-form]');
    var params = new URLSearchParams(queryString || '');
    var noMatchStates = getNativeRangeNoMatchStatesFromUrl('?' + (queryString || ''));
    var appliedTextFields = {};

    if (!form) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });

    params.forEach(function (value, name) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field.name !== name) {
          return;
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.value === value) {
            field.checked = true;
          }
        } else if (!appliedTextFields[name]) {
          field.value = value;
          appliedTextFields[name] = true;
        }
      });
    });

    applyNativeRangeNoMatchStatesToForm(form, noMatchStates);
    syncDeferredRangeUi(form);

    return true;
  }

  function updateDeferredRemoveUi(link) {
    var currentFilters = link.closest('.productgrid--sidebar-filters--current');
    var listItem = link.closest('li');

    if (!currentFilters) {
      return;
    }

    if (link.closest('.filter-item--grid-simple')) {
      currentFilters.remove();
      return;
    }

    if (listItem) {
      listItem.remove();
    }

    if (!currentFilters.querySelector('li')) {
      currentFilters.remove();
    }
  }

  function markDeferredDirty(instance) {
    var form;

    if (!instance) {
      return;
    }

    if (instance.timeout !== null) {
      clearTimeout(instance.timeout);
      instance.timeout = null;
    }

    instance.kkMobileDeferredDirty = true;
    activeDeferredInstance = instance;
    form = getModalFilterForm(instance);
    instance.kkNativeRangeNoMatchStates = collectNativeRangeNoMatchStates(form);
    renderMobileStagedFilters(form);
    queueLiveFacetRefresh(instance);
  }

  function queueDeferredApply(instance) {
    if (!instance || !instance.kkMobileDeferredDirty) {
      return;
    }

    pendingDeferredApplyInstance = instance;
  }

  function flushDeferredApply() {
    var instance = pendingDeferredApplyInstance;

    if (!instance || document.body.classList.contains('modal-visible')) {
      return;
    }

    pendingDeferredApplyInstance = null;

    if (!instance.kkMobileDeferredDirty) {
      return;
    }

    cancelLiveFacetRefresh();

    instance.kkMobileDeferredDirty = false;

    if (typeof instance._fetchResults === 'function') {
      instance.kkUseModalFilterFormForNextFetch = true;

      try {
        instance._fetchResults();
      } finally {
        instance.kkUseModalFilterFormForNextFetch = false;
      }
    }
  }

  function refreshOpenFilterModal(instance) {
    var modalWrapper = instance && instance.modal;
    var vanillaModal = modalWrapper && modalWrapper.modal;
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    var freshSource = instance && instance.el ? instance.el.querySelector(instance.filterContentSelector) : null;

    if (!modalWrapper || !vanillaModal || !modalContent || !freshSource) {
      if (modalWrapper && modalWrapper.isOpen && modalWrapper.isOpen()) {
        modalWrapper.close();
      }

      return;
    }

    while (modalContent.firstChild) {
      modalContent.removeChild(modalContent.firstChild);
    }

    while (freshSource.firstChild) {
      modalContent.appendChild(freshSource.firstChild);
    }

    vanillaModal.current = freshSource;
    modalWrapper.position();
  }

  function getSearchFilterBaseUrl(instance) {
    var scopedField = instance && instance.el && instance.el.querySelector('[data-search-filter-form] [data-href]');
    var modalScopedField = document.querySelector('[data-modal-container] [data-search-filter-form] [data-href]');
    var fallbackField = instance && instance.el && instance.el.querySelector('[data-productgrid-filters-content] [data-href]');
    var modalFallbackField = document.querySelector('[data-modal-container] [data-productgrid-filters-content] [data-href]');
    var href = scopedField ? scopedField.getAttribute('data-href') : '';

    if (!href && modalScopedField) {
      href = modalScopedField.getAttribute('data-href');
    }

    if (!href && fallbackField) {
      href = fallbackField.getAttribute('data-href');
    }

    if (!href && modalFallbackField) {
      href = modalFallbackField.getAttribute('data-href');
    }

    return href || window.location.pathname + window.location.search;
  }

  function getSearchFilterForm(instance) {
    var modalForm = instance && (instance.kkUseModalFilterFormForNextFetch || isMobileFilterModalOpen()) ?
      document.querySelector('[data-modal-container] ' + instance.filterFormSelector) :
      null;

    return modalForm || (
      instance && instance.el && instance.el.querySelector(instance.filterFormSelector)
    ) || document.querySelector(instance.filterFormSelector);
  }

  function buildDeferredSearchFetchUrl(instance, preferredForm) {
    var form = preferredForm || getSearchFilterForm(instance);
    var baseUrl;
    var url;
    var formData;
    var fieldNames = {};

    if (!form) {
      return '';
    }

    baseUrl = getSearchFilterBaseUrl(instance);

    try {
      url = new URL(baseUrl, window.location.origin);
    } catch (error) {
      return baseUrl;
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');
    formData = new FormData(form);

    Array.prototype.forEach.call(form.elements, function (field) {
      if (field && field.name) {
        fieldNames[field.name] = true;
      }
    });

    Object.keys(fieldNames).forEach(function (name) {
      url.searchParams.delete(name);
    });

    new URLSearchParams(formData).forEach(function (value, name) {
      url.searchParams.append(name, value);
    });

    setNativeRangeNoMatchStatesOnUrl(url, collectNativeRangeNoMatchStates(form));

    return url.pathname + url.search;
  }

  function buildSearchPaginationUrl(pageNumber) {
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('view');
    url.searchParams.set('page', String(pageNumber));

    return url.pathname + url.search;
  }

  function buildSearchRecoveryUrl(pageNumber) {
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('view');
    url.searchParams.set('sort_by', SEARCH_RECOVERY_SORT);
    url.searchParams.set('page', String(pageNumber));

    return url.pathname + url.search;
  }

  function getCurrentSearchSort() {
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    return url.searchParams.get('sort_by') || 'relevance';
  }

  function parseSearchResultTotal(value) {
    var normalized = value === null || value === undefined ? '' : String(value).trim();
    var total;

    if (!/^\d+$/.test(normalized)) {
      return null;
    }

    total = Number(normalized);

    return isFinite(total) && total >= 0 ? total : null;
  }

  function getSearchResponseNextPage(results) {
    var button = results && results.querySelector('[data-click-to-load]');
    var value = button && button.getAttribute('data-to-page');

    if (!value || !/^\d+$/.test(value.trim())) {
      return null;
    }

    value = Number(value);

    return isFinite(value) && value > 0 ? value : null;
  }

  function getSearchSummaryText(summary, count) {
    var attribute = count === 1 ? 'data-kk-search-summary-one' : 'data-kk-search-summary-other';
    var template = summary && summary.getAttribute(attribute);
    var token = summary && summary.getAttribute('data-kk-search-summary-token');
    var currentText;
    var currentCount;

    if (template) {
      return token && template.indexOf(token) !== -1 ?
        template.replace(token, String(count)) :
        template;
    }

    currentText = summary ? summary.textContent : '';
    currentCount = currentText.match(/\d[\d\s.,]*/);

    return currentCount ? currentText.replace(currentCount[0], String(count)) : currentText;
  }

  function syncSearchResultTotal(instance, results, count) {
    var summary;
    var modalForm;
    var sidebarForm;

    if (!instance || !results || !Number.isFinite(count) || count < 0) {
      return;
    }

    results.setAttribute('data-product-count', String(count));
    summary = instance.el && instance.el.querySelector('.kk-search-page__summary');

    if (summary) {
      summary.textContent = getSearchSummaryText(summary, count);
    }

    modalForm = getModalFilterForm(instance);
    sidebarForm = instance.el && instance.el.querySelector(
      instance.filterFormSelector || '[data-search-filter-form]'
    );

    if (modalForm) {
      updateLiveFacetResultCount(modalForm, count);
    }

    if (sidebarForm && sidebarForm !== modalForm) {
      updateLiveFacetResultCount(sidebarForm, count);
    }
  }

  function getNativeRangeNoResultsText() {
    var language = String(document.documentElement.lang || '').toLowerCase();

    if (language.indexOf('fi') === 0) {
      return 'Valituilla suodattimilla ei löytynyt tuotteita.';
    }

    if (language.indexOf('sv') === 0) {
      return 'Inga produkter hittades med de valda filtren.';
    }

    return 'No products were found with the selected filters.';
  }

  function getNativeRangeRemoveAllText() {
    var language = String(document.documentElement.lang || '').toLowerCase();

    if (language.indexOf('fi') === 0) return 'Poista kaikki';
    if (language.indexOf('sv') === 0) return 'Ta bort alla';
    return 'Remove all';
  }

  function buildNativeRangeNoMatchUrl(urlValue, states) {
    var url;

    try {
      url = new URL(String(urlValue || window.location.href), window.location.origin);
    } catch (error) {
      return String(urlValue || '');
    }

    url.searchParams.delete('page');
    setNativeRangeNoMatchStatesOnUrl(url, states || []);
    return url.pathname + url.search + url.hash;
  }

  function buildNativeRangeClearAllUrl(urlValue) {
    var url;
    var names = [];

    try {
      url = new URL(String(urlValue || window.location.href), window.location.origin);
    } catch (error) {
      return String(urlValue || '');
    }

    url.searchParams.forEach(function (value, name) {
      if (name.indexOf('filter.') === 0 || name === NATIVE_RANGE_NO_MATCH_PARAM || name === 'page') {
        names.push(name);
      }
    });
    names.forEach(function (name) {
      url.searchParams.delete(name);
    });

    return url.pathname + url.search + url.hash;
  }

  function getNativeRangeNoMatchLabel(form, state) {
    var root = findNativeRangeByKey(form, state.key);
    var facet = root && root.closest('[data-kk-facet]');
    var title = getFacetTitle(facet);
    var unit = root && root.getAttribute('data-kk-range-unit') || '';

    if (unit) {
      title = title.replace(new RegExp('\\s*\\(' + unit.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\)\\s*$', 'i'), '');
    }

    return (
      (title || state.key) + ': ' +
      state.lower + ' - ' + state.upper +
      (unit ? ' ' + unit : '')
    );
  }

  function updateSearchFilterCountForNoMatch(instance, increment) {
    var button = instance && instance.el && instance.el.querySelector('[data-productgrid-trigger-filters]');
    var text = button && button.querySelector('.utils-filter-text');

    function addToText(node, attribute) {
      var current = attribute ? node.getAttribute(attribute) : node.textContent;
      var baseAttribute = 'data-kk-native-range-count-base' + (attribute ? '-aria' : '');
      var base = node.getAttribute(baseAttribute) || current || '';
      var updated = base.replace(/\d+/, function (value) {
        return String(parseInt(value, 10) + increment);
      });

      node.setAttribute(baseAttribute, base);
      if (attribute) {
        node.setAttribute(attribute, updated);
      } else {
        node.textContent = updated;
      }
    }

    if (text && /\d+/.test(text.textContent || '')) {
      addToText(text);
    }
    if (button && /\d+/.test(button.getAttribute('aria-label') || '')) {
      addToText(button, 'aria-label');
    }
  }

  function ensureNativeRangeNoMatchActiveFilters(instance, results, form, states, sourceUrl) {
    var container = results.querySelector('.productgrid--filters');
    var list;
    var clearItem;
    var firstContent;

    if (!container) {
      container = document.createElement('div');
      container.className = 'productgrid--filters';
      list = document.createElement('ul');
      list.className = 'filter-group--grid';
      container.appendChild(list);
      firstContent = results.querySelector('.productgrid--utils, [data-product-grid], .productgrid--no-results');
      results.insertBefore(container, firstContent || results.firstChild);
    } else {
      list = container.querySelector('.filter-group--grid');
      if (!list) {
        list = document.createElement('ul');
        list.className = 'filter-group--grid';
        container.appendChild(list);
      }
    }

    list.querySelectorAll('[data-kk-native-range-no-match-chip]').forEach(function (item) {
      item.remove();
    });

    clearItem = list.querySelector('.filter-item--grid-simple');

    states.forEach(function (state) {
      var remaining = states.filter(function (candidate) {
        return candidate.key !== state.key;
      });
      var item = document.createElement('li');
      var link = document.createElement('a');
      var text = document.createElement('span');
      var icon = document.createElement('span');

      item.className = 'filter-item--grid';
      item.setAttribute('data-kk-native-range-no-match-chip', '');
      link.href = buildNativeRangeNoMatchUrl(sourceUrl, remaining);
      link.setAttribute('data-filter-remove', '');
      link.setAttribute('data-kk-native-range-no-match-remove', state.key);
      text.className = 'filter-text';
      text.textContent = getNativeRangeNoMatchLabel(form, state);
      icon.className = 'filter-icon--remove';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '×';
      link.appendChild(text);
      link.appendChild(icon);
      item.appendChild(link);
      list.insertBefore(item, clearItem || null);
    });

    if (!clearItem) {
      clearItem = document.createElement('li');
      clearItem.className = 'filter-item--grid-simple';
      clearItem.setAttribute('data-kk-native-range-no-match-clear', '');
      clearItem.appendChild(document.createElement('a'));
      list.appendChild(clearItem);
    }

    clearItem.querySelector('a').href = buildNativeRangeClearAllUrl(sourceUrl);
    clearItem.querySelector('a').setAttribute('data-filter-remove', '');
    if (!clearItem.querySelector('a').textContent.trim()) {
      clearItem.querySelector('a').textContent = getNativeRangeRemoveAllText();
    }

    updateSearchFilterCountForNoMatch(instance, states.length);
  }

  function renderNativeRangeNoMatchResultView(instance, form, states, sourceUrl) {
    var modalForm = getModalFilterForm(instance);
    var results = instance && instance.el && instance.el.querySelector('[data-results-container]');
    var grid;
    var noResults;

    if (!instance || !form || !results || !states.length) {
      return false;
    }

    grid = results.querySelector('[data-product-grid]');
    if (grid) {
      grid.hidden = true;
      grid.setAttribute('aria-hidden', 'true');
      grid.style.display = 'none';
    }

    noResults = results.querySelector('[data-kk-native-range-no-results]') ||
      results.querySelector('.productgrid--no-results');
    if (!noResults) {
      noResults = document.createElement('div');
      noResults.className = 'productgrid--no-results';
      noResults.innerHTML = '<h2 class="productgrid--no-results-title"></h2>';
      results.insertBefore(
        noResults,
        results.querySelector('[data-pagination-wrapper], nav.pagination__wrapper') || null
      );
    }
    noResults.setAttribute('data-kk-native-range-no-results', '');
    noResults.querySelector('.productgrid--no-results-title').textContent = getNativeRangeNoResultsText();

    results.querySelectorAll('[data-pagination-wrapper], nav.pagination__wrapper').forEach(function (pagination) {
      pagination.hidden = true;
      pagination.style.display = 'none';
    });

    syncSearchResultTotal(instance, results, 0);
    ensureNativeRangeNoMatchActiveFilters(instance, results, form, states, sourceUrl);
    if (modalForm) {
      renderMobileStagedFilters(modalForm);
    }

    return true;
  }

  function applyNativeRangeNoMatchView(instance, requestedStates, sourceUrl) {
    var form = instance && instance.el && instance.el.querySelector(
      instance.filterFormSelector || '[data-search-filter-form]'
    );
    var modalForm = getModalFilterForm(instance);
    var states = applyNativeRangeNoMatchStatesToForm(form, requestedStates || []);

    if (!instance || !form || !states.length) {
      if (instance) {
        instance.kkNativeRangeNoMatchStates = [];
      }
      return false;
    }

    instance.kkNativeRangeNoMatchStates = states;
    instance.kkNativeRangeNoMatchUrl = buildNativeRangeNoMatchUrl(sourceUrl, states);

    if (modalForm && modalForm !== form) {
      applyNativeRangeNoMatchStatesToForm(modalForm, states);
    }

    return renderNativeRangeNoMatchResultView(
      instance,
      form,
      states,
      instance.kkNativeRangeNoMatchUrl
    );
  }

  function queueResolvedNativeRangeRequest(instance, fetchUrl) {
    var retry;

    if (!instance || !fetchUrl || instance.kkNativeRangeResolutionPending) {
      return;
    }

    instance.kkNativeRangeResolutionPending = true;
    retry = function () {
      if (!instance.el || !instance.el.isConnected) {
        instance.kkNativeRangeResolutionPending = false;
        return;
      }

      if (instance.processing) {
        window.setTimeout(retry, 16);
        return;
      }

      instance.kkNativeRangeResolutionPending = false;
      instance._ajaxFetch(fetchUrl, 1, 'change');
    };

    window.setTimeout(retry, 0);
  }

  function reconcileNativeRangeNoMatchResponse(instance, requestedStates, sourceUrl) {
    var form = instance && instance.el && instance.el.querySelector(
      instance.filterFormSelector || '[data-search-filter-form]'
    );
    var states = requestedStates || [];
    var resolution;
    var fetchUrl;

    if (!instance || !form || !states.length) {
      return {
        active: false,
        refetch: false
      };
    }

    // The response form is Shopify's fresh facet state because the marker is
    // deliberately omitted from the network request. Re-evaluate the client
    // predicate against it instead of blindly keeping an old zero-result view.
    resolution = resolveNativeRangeNoMatchStates(form, form, states);

    if (resolution.converted.length) {
      instance.kkNativeRangeNoMatchStates = resolution.remaining;
      fetchUrl = buildDeferredSearchFetchUrl(instance, form);
      instance.kkNativeRangeNoMatchUrl = buildNativeRangeNoMatchUrl(
        fetchUrl || sourceUrl,
        resolution.remaining
      );

      // Do not flash Shopify's unfiltered marker response while the canonical
      // exact-value request is queued.
      renderNativeRangeNoMatchResultView(
        instance,
        form,
        states,
        buildNativeRangeNoMatchUrl(sourceUrl, states)
      );
      queueResolvedNativeRangeRequest(instance, instance.kkNativeRangeNoMatchUrl);

      return {
        active: true,
        refetch: true
      };
    }

    return {
      active: applyNativeRangeNoMatchView(instance, resolution.remaining, sourceUrl),
      refetch: false
    };
  }

  function focusSearchElement(element) {
    if (!element || !element.isConnected || typeof element.focus !== 'function') {
      return;
    }

    element.focus();
  }

  function getSearchProductItemKey(item) {
    var link = item && item.querySelector(
      '.productitem--title a[href], [data-product-page-link][href]'
    );
    var url;

    if (!link) {
      return '';
    }

    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
      return url.pathname;
    } catch (error) {
      return link.getAttribute('href') || '';
    }
  }

  function getSearchProductFocusTarget(item) {
    return item && item.querySelector(
      '.productitem--title a[href], [data-product-page-link][href], a[href], button:not([disabled]), [tabindex="0"]'
    );
  }

  function setSearchPaginationBusy(instance, button, results, busy) {
    if (button && button.isConnected) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    if (results && results.isConnected) {
      if (busy) {
        results.setAttribute('aria-busy', 'true');
      } else {
        results.removeAttribute('aria-busy');
      }
    }
  }

  function commitSearchPaginationResponse(instance, result, options) {
    var currentPagination = result.currentPagination;
    var currentPaginationNav = result.currentPaginationNav;
    var nextPagination = result.nextPagination;
    var nextPaginationNav = result.nextPaginationNav;

    options = options || {};

    if (options.clearPagination) {
      currentPagination.innerHTML = '';

      if (currentPaginationNav) {
        currentPaginationNav.remove();
      }
    } else {
      currentPagination.innerHTML = nextPagination ? nextPagination.innerHTML : '';

      if (currentPaginationNav && nextPaginationNav) {
        currentPaginationNav.replaceWith(document.importNode(nextPaginationNav, true));
      } else if (currentPaginationNav) {
        currentPaginationNav.remove();
      } else if (nextPaginationNav) {
        currentPagination.insertAdjacentElement(
          'afterend',
          document.importNode(nextPaginationNav, true)
        );
      }
    }

    if (Number.isFinite(options.total)) {
      syncSearchResultTotal(instance, result.currentResults, options.total);
    }

    result.nextButton = result.currentResults.querySelector('[data-click-to-load]');

    return result;
  }

  function appendSearchPaginationResponse(instance, responseRoot, options) {
    var currentGrid = instance.el.querySelector('[data-product-grid]');
    var nextGrid = responseRoot && responseRoot.querySelector('[data-product-grid]');
    var currentResults = instance.el.querySelector('[data-results-container]');
    var nextResults = responseRoot && responseRoot.querySelector('[data-results-container]');
    var currentPagination = currentResults && currentResults.querySelector(
      '[data-pagination-wrapper][data-html="pagination"]'
    );
    var nextPagination = nextResults && nextResults.querySelector(
      '[data-pagination-wrapper][data-html="pagination"]'
    );
    var currentPaginationNav = currentResults && currentResults.querySelector('nav.pagination__wrapper');
    var nextPaginationNav = nextResults && nextResults.querySelector('nav.pagination__wrapper');
    var currentItems;
    var currentTotal;
    var responseTotal;
    var reportedTotal;
    var responseItems;
    var responseNextPage;
    var existingKeys = new Set();
    var fragment = document.createDocumentFragment();
    var appendedItems = [];

    options = options || {};

    if (!currentGrid || !currentResults || !nextResults || !currentPagination) {
      throw new Error('Search pagination response is missing required markup.');
    }

    currentItems = currentGrid.querySelectorAll('[data-product-item]');
    currentTotal = parseSearchResultTotal(currentResults.getAttribute('data-product-count'));
    responseTotal = parseSearchResultTotal(nextResults.getAttribute('data-product-count'));
    reportedTotal = currentTotal;

    if (responseTotal !== null && (reportedTotal === null || responseTotal > reportedTotal)) {
      reportedTotal = responseTotal;
    }

    responseItems = nextGrid ? nextGrid.querySelectorAll('[data-product-item]') : [];
    responseNextPage = getSearchResponseNextPage(nextResults);

    if (!nextGrid && currentTotal === null) {
      throw new Error('Search pagination response is missing required markup.');
    }

    currentItems.forEach(function (item) {
      var key = getSearchProductItemKey(item);

      if (key) {
        existingKeys.add(key);
      }
    });

    responseItems.forEach(function (item) {
      var key = getSearchProductItemKey(item);
      var clone;

      if (key && existingKeys.has(key)) {
        return;
      }

      clone = document.importNode(item, true);
      appendedItems.push(clone);
      fragment.appendChild(clone);

      if (key) {
        existingKeys.add(key);
      }
    });

    if (responseItems.length && !appendedItems.length && currentTotal === null) {
      throw new Error('Search pagination response contains only duplicate products.');
    }

    currentGrid.appendChild(fragment);

    if (reportedTotal !== null) {
      reportedTotal = Math.max(
        reportedTotal,
        currentGrid.querySelectorAll('[data-product-item]').length
      );
    }

    var result = {
      appendedItems: appendedItems,
      currentGrid: currentGrid,
      currentResults: currentResults,
      currentPagination: currentPagination,
      currentPaginationNav: currentPaginationNav,
      currentTotal: currentTotal,
      nextPagination: nextPagination,
      nextPaginationNav: nextPaginationNav,
      nextButton: null,
      renderedCount: currentGrid.querySelectorAll('[data-product-item]').length,
      reportedTotal: reportedTotal,
      responseItemCount: responseItems.length,
      duplicateCount: Math.max(0, responseItems.length - appendedItems.length),
      responseNextPage: responseNextPage,
      responseTotal: responseTotal
    };

    if (!options.deferPagination) {
      commitSearchPaginationResponse(instance, result, {
        clearPagination: responseNextPage === null,
        total: currentTotal === null ? null : reportedTotal
      });
    }

    return result;
  }

  function fetchSearchPaginationRoot(fetchUrl, requestOptions) {
    return fetch(kkStripNativeRangeNoMatchRequestParam(fetchUrl), requestOptions).then(function (response) {
      if (!response.ok) {
        throw new Error('Search pagination request failed with status ' + response.status + '.');
      }

      return response.text();
    }).then(function (markup) {
      var parsed = new DOMParser().parseFromString(markup, 'text/html');
      var responseRoot = parsed.querySelector('.search--section [data-html]') ||
        parsed.querySelector('[data-html]');

      if (!responseRoot) {
        throw new Error('Search pagination response is missing its root markup.');
      }

      return responseRoot;
    });
  }

  function mergeSearchPaginationResult(aggregate, result) {
    Array.prototype.push.apply(aggregate.appendedItems, result.appendedItems);
    aggregate.lastResult = result;

    if (
      result.reportedTotal !== null &&
      (aggregate.reportedTotal === null || result.reportedTotal > aggregate.reportedTotal)
    ) {
      aggregate.reportedTotal = result.reportedTotal;
    }

    return aggregate;
  }

  function runSearchPaginationRecovery(
    instance,
    requestToken,
    aggregate,
    requestOptions,
    pageNumber,
    state
  ) {
    var fetchUrl;

    if (
      !pageNumber ||
      pageNumber < 1 ||
      state.visited[pageNumber] ||
      state.requestCount >= SEARCH_RECOVERY_MAX_PAGES
    ) {
      return Promise.resolve(aggregate);
    }

    fetchUrl = buildSearchRecoveryUrl(pageNumber);

    if (!fetchUrl) {
      return Promise.resolve(aggregate);
    }

    state.visited[pageNumber] = true;
    state.requestCount += 1;
    requestToken.recoveryStarted = true;

    return fetchSearchPaginationRoot(fetchUrl, requestOptions).then(function (responseRoot) {
      var result;
      var nextPage;

      if (
        instance.kkSearchLoadMoreRequest !== requestToken ||
        !instance.el ||
        !instance.el.isConnected
      ) {
        return aggregate;
      }

      result = appendSearchPaginationResponse(instance, responseRoot, {
        deferPagination: true
      });
      mergeSearchPaginationResult(aggregate, result);

      if (!result.responseItemCount) {
        return aggregate;
      }

      nextPage = result.responseNextPage;

      if (
        !nextPage ||
        nextPage <= pageNumber ||
        state.visited[nextPage]
      ) {
        return aggregate;
      }

      return runSearchPaginationRecovery(
        instance,
        requestToken,
        aggregate,
        requestOptions,
        nextPage,
        state
      );
    });
  }

  function rebindSearchPaginationInstance(instance, results) {
    if (instance.ajaxEvents && typeof instance.ajaxEvents.unregisterAll === 'function') {
      instance.ajaxEvents.unregisterAll();
    }

    if (typeof instance._initProducts === 'function') {
      instance._initProducts();
    }

    if (results && results.dispatchEvent) {
      results.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
    }

    if (typeof instance._bindEvents === 'function') {
      instance._bindEvents();
    }
  }

  function restoreSearchPaginationFocus(trigger, focusOwned, appendResult) {
    var active = document.activeElement;
    var focusIsLost = !active ||
      active === document.body ||
      active === document.documentElement ||
      !active.isConnected ||
      active === trigger;
    var target;

    if (!focusOwned || !focusIsLost || !appendResult) {
      return;
    }

    target = appendResult.nextButton;

    if (!target && appendResult.appendedItems.length) {
      target = getSearchProductFocusTarget(appendResult.appendedItems[0]);
    }

    if (!target) {
      target = getSearchProductFocusTarget(appendResult.currentGrid.lastElementChild);
    }

    focusSearchElement(target);
  }

  function cancelSearchClickToLoad(instance) {
    var request = instance && instance.kkSearchLoadMoreRequest;

    if (!request) {
      return;
    }

    instance.kkSearchLoadMoreRequest = null;

    if (request.controller) {
      request.controller.abort();
    }

    setSearchPaginationBusy(instance, request.trigger, request.results, false);
  }

  function cancelActiveSearchClickToLoad() {
    var instance = getDeferredInstance();

    if (instance) {
      cancelSearchClickToLoad(instance);
    }
  }

  function handleSearchClickToLoad(instance, event) {
    var trigger = event.currentTarget;
    var pageNumber = parseInt(trigger.getAttribute('data-to-page'), 10);
    var fetchUrl = buildSearchPaginationUrl(pageNumber);
    var results = instance.el.querySelector('[data-results-container]');
    var active = document.activeElement;
    var focusOwned = active === trigger || trigger.contains(active);
    var requestToken;
    var aggregate = {
      appendedItems: [],
      lastResult: null,
      primaryResult: null,
      reportedTotal: null
    };
    var requestOptions = {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };

    event.preventDefault();
    event.stopPropagation();

    if (
      instance.kkSearchLoadMoreRequest ||
      instance.processing ||
      !pageNumber ||
      pageNumber < 1 ||
      !fetchUrl ||
      !results
    ) {
      return;
    }

    requestToken = {
      controller: typeof AbortController === 'function' ? new AbortController() : null,
      recoveryStarted: false,
      results: results,
      trigger: trigger
    };
    instance.kkSearchLoadMoreRequest = requestToken;
    setSearchPaginationBusy(instance, trigger, results, true);

    if (requestToken.controller) {
      requestOptions.signal = requestToken.controller.signal;
    }

    fetchSearchPaginationRoot(fetchUrl, requestOptions).then(function (responseRoot) {
      var appendResult;
      var shouldRecover;

      if (
        instance.kkSearchLoadMoreRequest !== requestToken ||
        !instance.el ||
        !instance.el.isConnected
      ) {
        return;
      }

      appendResult = appendSearchPaginationResponse(instance, responseRoot, {
        deferPagination: true
      });
      aggregate.primaryResult = appendResult;
      mergeSearchPaginationResult(aggregate, appendResult);

      if (appendResult.duplicateCount > 0) {
        instance.kkSearchPaginationHadDuplicates = true;
      }

      shouldRecover = appendResult.currentTotal !== null &&
        appendResult.responseNextPage === null &&
        getCurrentSearchSort() === 'relevance' &&
        (
          appendResult.renderedCount !== appendResult.reportedTotal ||
          instance.kkSearchPaginationHadDuplicates
        );

      if (shouldRecover) {
        return runSearchPaginationRecovery(
          instance,
          requestToken,
          aggregate,
          requestOptions,
          1,
          {
            requestCount: 0,
            visited: Object.create(null)
          }
        ).then(function () {
          return {
            clearPagination: true,
            total: appendResult.currentGrid.querySelectorAll('[data-product-item]').length
          };
        });
      }

      return {
        clearPagination: appendResult.responseNextPage === null,
        total: appendResult.currentTotal === null ?
          null :
          (appendResult.responseNextPage === null ?
            appendResult.renderedCount :
            appendResult.reportedTotal)
      };
    }).then(function (outcome) {
      var appendResult;

      if (
        !outcome ||
        instance.kkSearchLoadMoreRequest !== requestToken ||
        !aggregate.primaryResult ||
        !instance.el ||
        !instance.el.isConnected
      ) {
        return;
      }

      appendResult = commitSearchPaginationResponse(instance, aggregate.primaryResult, outcome);
      appendResult.appendedItems = aggregate.appendedItems;

      if (outcome.clearPagination) {
        instance.kkSearchPaginationHadDuplicates = false;
      }

      rebindSearchPaginationInstance(instance, appendResult.currentResults);
      instance.kkSearchLoadMoreRequest = null;
      setSearchPaginationBusy(instance, trigger, appendResult.currentResults, false);

      window.requestAnimationFrame(function () {
        restoreSearchPaginationFocus(trigger, focusOwned, appendResult);
      });
    }).catch(function () {
      var partialResult;

      if (instance.kkSearchLoadMoreRequest !== requestToken) {
        return;
      }

      instance.kkSearchLoadMoreRequest = null;
      setSearchPaginationBusy(instance, trigger, results, false);

      if (aggregate.primaryResult) {
        if (aggregate.reportedTotal !== null) {
          syncSearchResultTotal(
            instance,
            aggregate.primaryResult.currentResults,
            Math.max(
              aggregate.reportedTotal,
              aggregate.primaryResult.currentGrid.querySelectorAll('[data-product-item]').length
            )
          );
        }

        rebindSearchPaginationInstance(instance, aggregate.primaryResult.currentResults);
        partialResult = {
          appendedItems: aggregate.appendedItems,
          currentGrid: aggregate.primaryResult.currentGrid,
          currentResults: aggregate.primaryResult.currentResults,
          nextButton: trigger && trigger.isConnected ? trigger : null
        };

        window.requestAnimationFrame(function () {
          restoreSearchPaginationFocus(trigger, focusOwned, partialResult);
        });
        return;
      }

      if (!requestToken.recoveryStarted) {
        window.location.assign(fetchUrl);
      }
    });
  }

  function patchStaticSearchInstance(instance) {
    var searchInstance = instance;
    var originalPopstate;
    var originalHandleFilterClick;
    var originalHandlePaginationClick;
    var originalHandleRangeInput;
    var originalAjaxFetch;
    var originalGetFilterQuery;
    var originalInitProducts;

    if (!instance || instance.kkMobileDeferredPatched) {
      return;
    }

    originalHandleFilterClick = instance._handleFilterClick;
    originalHandlePaginationClick = instance._handlePaginationClick;
    originalHandleRangeInput = instance._handleRangeInput;
    originalAjaxFetch = instance._ajaxFetch;
    originalGetFilterQuery = instance._getFilterQuery;
    originalInitProducts = instance._initProducts;

    if (typeof originalInitProducts === 'function') {
      instance._initProducts = function () {
        var result = originalInitProducts.apply(searchInstance, arguments);
        var noMatchResolution = {
          active: false,
          refetch: false
        };

        if (searchInstance.kkNativeRangeNoMatchStates && searchInstance.kkNativeRangeNoMatchStates.length) {
          noMatchResolution = reconcileNativeRangeNoMatchResponse(
            searchInstance,
            searchInstance.kkNativeRangeNoMatchStates,
            searchInstance.kkNativeRangeNoMatchUrl || window.location.href
          );
        }

        if (!noMatchResolution.refetch) {
          document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
            detail: {
              source: 'native-search'
            }
          }));

          /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
          queueDesktopSearchFilterFocusRestore(searchInstance);
          /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */
        }

        return result;
      };
    }

    instance._getFilterQuery = function (targetEl) {
      if (targetEl && targetEl.hasAttribute && targetEl.hasAttribute('data-filter-remove')) {
        return originalGetFilterQuery.call(searchInstance, targetEl);
      }

      var modalContainer = document.querySelector('[data-modal-container]');
      var modalForm = modalContainer && modalContainer.classList.contains('modal--productgrid-filters') ?
        modalContainer.querySelector(searchInstance.filterFormSelector) :
        null;
      var instanceForm = searchInstance.el && searchInstance.el.querySelector(searchInstance.filterFormSelector);
      var form = modalForm || instanceForm;

      if (!form) {
        return '';
      }

      return addNativeRangeNoMatchStatesToQuery(
        new URLSearchParams(new FormData(form)).toString(),
        collectNativeRangeNoMatchStates(form)
      );
    };

    instance._fetchResults = function () {
      var fetchUrl;

      if (searchInstance.processing) {
        return;
      }

      fetchUrl = buildDeferredSearchFetchUrl(searchInstance);

      if (!fetchUrl) {
        return;
      }

      searchInstance._ajaxFetch(fetchUrl, 1, 'change');
    };

    instance._ajaxFetch = function () {
      var args = Array.prototype.slice.call(arguments);
      var request = args[0];
      var eventType = args[2] || '';
      var nativeFetch;
      var requestUrl = typeof request === 'string' ? request : (
        request && request.currentTarget && request.currentTarget.getAttribute ?
          request.currentTarget.getAttribute('href') :
          ''
      );
      var form = getSearchFilterForm(searchInstance);
      var states = eventType === 'change' ?
        collectNativeRangeNoMatchStates(form) :
        (requestUrl ? getNativeRangeNoMatchStatesFromUrl(requestUrl) : collectNativeRangeNoMatchStates(form));

      if (typeof request === 'string') {
        requestUrl = buildNativeRangeNoMatchUrl(requestUrl, states);
        args[0] = requestUrl;
      }

      cancelSearchClickToLoad(searchInstance);
      searchInstance.kkSearchPaginationHadDuplicates = false;
      searchInstance.kkMobileDeferredDirty = false;
      searchInstance.kkNativeRangeNoMatchStates = states;
      searchInstance.kkNativeRangeNoMatchUrl = requestUrl || buildNativeRangeNoMatchUrl(
        window.location.href,
        states
      );
      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
      markDesktopSearchFilterRequest(searchInstance, args[0]);
      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

      // Superstore uses this same URL both for fetch() and history.pushState().
      // Strip the client marker from the synchronous network call only, so it
      // remains restorable in the browser URL without becoming an unsupported
      // Shopify filter parameter.
      nativeFetch = window.fetch;
      window.fetch = function (input, options) {
        return nativeFetch.call(
          window,
          kkStripNativeRangeNoMatchRequestParam(input),
          options
        );
      };

      try {
        return originalAjaxFetch.apply(searchInstance, args);
      } finally {
        window.fetch = nativeFetch;
      }
    };

    instance._handleFilterClick = function (event) {
      var target;
      var filterItem;

      cancelSearchClickToLoad(searchInstance);

      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
      if (!isMobile()) {
        rememberDesktopSearchFilterFocus(searchInstance, event.currentTarget || event.target);
      }
      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

      if (isMobileFilterModalOpen()) {
        target = event.currentTarget || event.target;
        filterItem = target && target.closest('[data-filter-item]');

        if (filterItem) {
          filterItem.classList.toggle('filter-item--active', Boolean(target.checked));
          filterItem.classList.toggle('filter-item--inactive', !target.checked);
        }

        markDeferredDirty(searchInstance);
        return;
      }

      return originalHandleFilterClick(event);
    };

    instance._handleRangeInput = function (event) {
      if (event.key !== 'Tab') {
        cancelSearchClickToLoad(searchInstance);
      }

      if (isMobileFilterModalOpen()) {
        if (event.key === 'Tab') {
          return;
        }

        markDeferredDirty(searchInstance);
        return;
      }

      return originalHandleRangeInput(event);
    };

    instance.paginationSelector = 'a.pagination__item, [data-click-to-load]';
    instance._handlePaginationClick = function (event) {
      var target = event.currentTarget;

      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
      cancelDesktopSearchFilterFocus();
      /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

      if (target && target.hasAttribute('data-click-to-load')) {
        return handleSearchClickToLoad(searchInstance, event);
      }

      return originalHandlePaginationClick(event);
    };

    instance.kkMobileDeferredPatched = true;

    if (instance.ajaxEvents && typeof instance.ajaxEvents.unregisterAll === 'function') {
      instance.ajaxEvents.unregisterAll();
    }

    if (typeof instance._bindEvents === 'function') {
      instance._bindEvents();
    }

    originalPopstate = window.onpopstate;
    if (!instance.kkNativeRangePopstatePatched && typeof originalPopstate === 'function') {
      window.onpopstate = function (event) {
        if (!event || !event.state || !event.state.path) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          searchInstance._ajaxFetch(
            window.location.pathname + window.location.search,
            1,
            'popstate'
          );
          return;
        }

        return originalPopstate.call(window, event);
      };
      instance.kkNativeRangePopstatePatched = true;
    }

    instance.kkNativeRangeNoMatchStates = getNativeRangeNoMatchStatesFromUrl(window.location.href);
    instance.kkNativeRangeNoMatchUrl = window.location.pathname + window.location.search;
    if (instance.kkNativeRangeNoMatchStates.length) {
      reconcileNativeRangeNoMatchResponse(
        instance,
        instance.kkNativeRangeNoMatchStates,
        instance.kkNativeRangeNoMatchUrl
      );
    }
  }

  function patchStaticSearchFaceted() {
    var instances = window.bcSections && window.bcSections.instances;
    var matchingInstanceFound = false;

    if (!instances || !window.bcStaticSearch) {
      return false;
    }

    Object.keys(instances).forEach(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticSearch) {
        matchingInstanceFound = true;
        patchStaticSearchInstance(instance);
      }
    });

    return matchingInstanceFound;
  }

  function cancelStaticSearchPatchRetry() {
    if (staticSearchPatchRetryTimer !== null) {
      window.clearTimeout(staticSearchPatchRetryTimer);
      staticSearchPatchRetryTimer = null;
    }

    staticSearchPatchAttempt = 0;
  }

  function runStaticSearchPatchAttempt() {
    staticSearchPatchRetryTimer = null;
    staticSearchPatchAttempt += 1;

    if (
      patchStaticSearchFaceted() ||
      staticSearchPatchAttempt >= STATIC_SEARCH_PATCH_MAX_ATTEMPTS
    ) {
      staticSearchPatchAttempt = 0;
      return;
    }

    staticSearchPatchRetryTimer = window.setTimeout(
      runStaticSearchPatchAttempt,
      STATIC_SEARCH_PATCH_RETRY_DELAY_MS
    );
  }

  function scheduleStaticSearchFacetedPatch() {
    cancelStaticSearchPatchRetry();
    runStaticSearchPatchAttempt();
  }

  function handleDeferredNativeChange(event) {
    var instance;

    if (!isMobileFilterModalOpen()) {
      return;
    }

    if (event.type === 'keyup' && event.key === 'Tab') {
      return;
    }

    if (!event.target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    )) {
      return;
    }

    instance = getDeferredInstance();

    if (instance) {
      markDeferredDirty(instance);
    }
  }

  document.addEventListener('change', handleDeferredNativeChange, true);
  document.addEventListener('keyup', handleDeferredNativeChange, true);

  function primeLiveFacetSessionFromInteraction(event) {
    if (
      isMobileFilterModalOpen() &&
      event.target &&
      event.target.closest &&
      event.target.closest(
        '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
      )
    ) {
      primeLiveFacetSession();
    }
  }

  document.addEventListener('pointerdown', primeLiveFacetSessionFromInteraction, true);
  document.addEventListener('pointerdown', trackLiveFacetPointer, true);
  document.addEventListener('pointerup', releaseLiveFacetPointer, true);
  document.addEventListener('pointercancel', releaseLiveFacetPointer, true);
  document.addEventListener('keydown', primeLiveFacetSessionFromInteraction, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-filter-remove]');
    var instance;
    var states;
    var removeKey;
    var requestUrl;
    var inModal;

    if (!link) {
      return;
    }

    instance = getDeferredInstance();
    states = instance && instance.kkNativeRangeNoMatchStates || [];
    inModal = Boolean(link.closest('[data-modal-container].modal--productgrid-filters'));
    if (
      !instance ||
      !states.length ||
      !instance.el ||
      (!instance.el.contains(link) && !inModal)
    ) {
      return;
    }

    removeKey = link.getAttribute('data-kk-native-range-no-match-remove');
    if (removeKey) {
      states = states.filter(function (state) {
        return state.key !== removeKey;
      });
      requestUrl = buildNativeRangeNoMatchUrl(link.getAttribute('href'), states);
    } else if (link.closest('.filter-item--grid-simple')) {
      states = [];
      requestUrl = buildNativeRangeClearAllUrl(link.getAttribute('href'));
    } else {
      requestUrl = buildNativeRangeNoMatchUrl(link.getAttribute('href'), states);
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    instance.kkNativeRangeNoMatchStates = states;
    instance.kkNativeRangeNoMatchUrl = requestUrl;

    if (inModal && isMobileFilterModalOpen()) {
      applyQueryToFilterForm(getQueryStringFromHref(requestUrl));
      updateDeferredRemoveUi(link);
      instance.kkNativeRangeNoMatchStates = collectNativeRangeNoMatchStates(getModalFilterForm(instance));
      markDeferredDirty(instance);
      return;
    }

    instance._ajaxFetch(requestUrl, 1, 'click');
  }, true);

  document.addEventListener('click', function (event) {
    var instance;
    var removeLink;
    var stagedRemove;
    var insideModal = event.target.closest('[data-modal-inner]');

    if (!isMobileFilterModalOpen()) {
      return;
    }

    stagedRemove = event.target.closest('[data-kk-staged-filter-remove]');

    if (stagedRemove) {
      event.preventDefault();
      window.setTimeout(function () {
        if (stagedRemove.isConnected) {
          removeMobileStagedFilter(stagedRemove);
        }
      }, 0);
      return;
    }

    removeLink = event.target.closest('[data-filter-remove]');

    if (removeLink) {
      instance = getDeferredInstance();

      if (!instance) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      applyQueryToFilterForm(getQueryStringFromHref(removeLink.getAttribute('href')));
      updateDeferredRemoveUi(removeLink);
      markDeferredDirty(instance);
      return;
    }

    if (event.target.closest('[data-modal-close]') || !insideModal) {
      cancelLiveFacetRefresh();
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isMobileFilterModalOpen()) {
      cancelLiveFacetRefresh();
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (isMobileFilterModalOpen() && !liveFacetSessionOpen) {
        window.setTimeout(function () {
          primeLiveFacetSession();
        }, 0);
      } else if (!document.body.classList.contains('modal-visible') && liveFacetSessionOpen) {
        cancelLiveFacetRefresh();
      }
      flushDeferredApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  document.addEventListener('kk:close-productgrid-filters', cancelLiveFacetRefresh);
  window.addEventListener('pagehide', cancelLiveFacetRefresh);
  window.addEventListener('popstate', cancelLiveFacetRefresh);
  window.addEventListener('resize', syncFacetOptionsForBreakpoint);

  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_START */
  document.addEventListener('focusin', function (event) {
    var intent = desktopSearchFilterFocusIntent;
    var target = event.target;

    if (
      !intent ||
      !target ||
      target === document.body ||
      target === document.documentElement ||
      !target.isConnected ||
      target === intent.owner ||
      (intent.owner && intent.owner.contains && intent.owner.contains(target))
    ) {
      return;
    }

    cancelDesktopSearchFilterFocus();
  }, true);
  document.addEventListener('shopify:section:load', cancelDesktopSearchFilterFocus);
  document.addEventListener('shopify:section:unload', cancelDesktopSearchFilterFocus);
  window.addEventListener('pagehide', cancelDesktopSearchFilterFocus);
  window.addEventListener('popstate', cancelDesktopSearchFilterFocus);
  window.addEventListener('resize', function () {
    if (isMobile()) {
      cancelDesktopSearchFilterFocus();
    }
  });
  /* KK_DESKTOP_SEARCH_FILTER_FOCUS_END */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleStaticSearchFacetedPatch();
      primeLiveFacetSession();
    });
  } else {
    scheduleStaticSearchFacetedPatch();
    primeLiveFacetSession();
  }

  window.addEventListener('theme:superstore:core-ready', scheduleStaticSearchFacetedPatch);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(scheduleStaticSearchFacetedPatch, 0);
  });
  document.addEventListener('shopify:section:unload', cancelStaticSearchPatchRetry);
  window.addEventListener('pagehide', cancelStaticSearchPatchRetry);
  document.addEventListener('shopify:section:unload', cancelActiveSearchClickToLoad);
  window.addEventListener('pagehide', cancelActiveSearchClickToLoad);
  window.addEventListener('popstate', function () {
    var instance = getDeferredInstance();

    if (instance) {
      cancelSearchClickToLoad(instance);
    }
  });
}());

(function () {
  var SEARCH_VIEW_STORAGE_KEY = 'kk-search-view';
  var viewApplyTimer = null;

  function isMobileSearchLayout() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function isSearchSectionElement(element) {
    return Boolean(element && element.closest && element.closest('.search--section'));
  }

  function getSearchOuter(element) {
    if (!isSearchSectionElement(element)) {
      return null;
    }

    return element.closest('.productgrid--outer');
  }

  function normalizeView(view) {
    return view === 'list-view' ? 'list-view' : 'grid-view';
  }

  function getStoredView() {
    return 'grid-view';
  }

  function setStoredView() {}

  function applySearchView(root, view) {
    var normalizedView = normalizeView(view);

    if (!root || !isSearchSectionElement(root)) {
      return;
    }

    root.classList.remove('productgrid-gridview', 'productgrid-listview');
    root.classList.add(normalizedView === 'list-view' ? 'productgrid-listview' : 'productgrid-gridview');

    root.querySelectorAll('[data-collection-view]').forEach(function (button) {
      button.classList.toggle(
        'active',
        button.getAttribute('data-collection-view') === normalizedView
      );
    });
  }

  function applyAllSearchViews() {
    var view = getStoredView();

    document.querySelectorAll('.search--section .productgrid--outer').forEach(function (root) {
      applySearchView(root, view);
    });
  }

  function queueApplyAllSearchViews() {
    window.clearTimeout(viewApplyTimer);
    viewApplyTimer = window.setTimeout(applyAllSearchViews, 30);
  }

  function findSearchInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticSearch) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticSearch) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function buildSearchUrl(updater) {
    var url = new URL(window.location.href);

    if (typeof updater === 'function') {
      updater(url.searchParams);
    }

    url.searchParams.delete('page');
    url.searchParams.delete('view');

    return url.pathname + (url.search ? url.search : '');
  }

  document.addEventListener('click', function (event) {
    var viewButton = event.target.closest('[data-collection-view]');

    if (viewButton && isSearchSectionElement(viewButton)) {
      var view = normalizeView(viewButton.getAttribute('data-collection-view'));

      event.preventDefault();
      setStoredView(view);
      applySearchView(getSearchOuter(viewButton), view);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var sortSelect = event.target.closest('[data-productgrid-trigger-sort]');
    var instance;
    var fetchUrl;

    if (!sortSelect || !isSearchSectionElement(sortSelect)) {
      return;
    }

    fetchUrl = buildSearchUrl(function (params) {
      if (sortSelect.value) {
        params.set('sort_by', sortSelect.value);
      } else {
        params.delete('sort_by');
      }
    });

    instance = findSearchInstance();

    if (instance && typeof instance._ajaxFetch === 'function') {
      instance._ajaxFetch(fetchUrl, 1, 'change');
    } else {
      window.location.assign(fetchUrl);
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(queueApplyAllSearchViews).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAllSearchViews);
  } else {
    applyAllSearchViews();
  }

  window.addEventListener('popstate', queueApplyAllSearchViews);
}());

(function () {
  var VENDOR_LOGO_VIEW = 'kk-vendor-logos';
  var vendorLogoPromise = null;
  var vendorLogos = new Map();
  var hydrationTimer = null;

  function normalizeVendorLogoKey(value) {
    var normalized = String(value || '').trim().toLowerCase();

    if (typeof normalized.normalize === 'function') {
      normalized = normalized.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    return normalized.replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '');
  }

  function normalizeVendorLogoUrl(value) {
    var url = String(value || '').trim();

    if (!url || (!/^(?:https?:)?\/\//i.test(url) && url.charAt(0) !== '/')) {
      return '';
    }

    return url;
  }

  function buildVendorLogoUrl() {
    var url;
    var searchTerm = '';

    try {
      url = new URL(window.location.href);
      searchTerm = url.searchParams.get('q') || '';
      url.search = '';
      url.searchParams.set('view', VENDOR_LOGO_VIEW);

      if (searchTerm) {
        url.searchParams.set('q', searchTerm);
      }

      return url.pathname + url.search;
    } catch (error) {
      return '/search?view=' + encodeURIComponent(VENDOR_LOGO_VIEW);
    }
  }

  function buildVendorLogoMap(payload) {
    var map = new Map();
    var vendors = payload && Array.isArray(payload.vendors) ? payload.vendors : [];

    vendors.forEach(function (vendor) {
      var logoUrl = normalizeVendorLogoUrl(vendor && vendor.logo);

      if (!logoUrl) {
        return;
      }

      [vendor.name, vendor.handle].forEach(function (value) {
        var key = normalizeVendorLogoKey(value);

        if (key && !map.has(key)) {
          map.set(key, { url: logoUrl });
        }
      });
    });

    return map;
  }

  function fetchVendorLogos() {
    if (vendorLogoPromise) {
      return vendorLogoPromise;
    }

    vendorLogoPromise = fetch(kkStripNativeRangeNoMatchRequestParam(buildVendorLogoUrl()), {
      credentials: 'same-origin',
      priority: 'low'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Search vendor logo view failed: ' + response.status);
      }

      return response.json();
    }).then(function (payload) {
      vendorLogos = buildVendorLogoMap(payload);
      return vendorLogos;
    }).catch(function () {
      // Logos are decorative. A missing or unpublished metaobject must not
      // delay or disable the native search filters.
      return vendorLogos;
    });

    return vendorLogoPromise;
  }

  function hydrateVendorLogoSlot(slot) {
    var key;
    var logo;
    var image;

    if (!slot || slot.querySelector('.kk-facet__vendor-logo')) {
      return;
    }

    key = normalizeVendorLogoKey(slot.getAttribute('data-kk-vendor-name'));
    logo = key ? vendorLogos.get(key) : null;

    if (!logo || !logo.url) {
      return;
    }

    image = document.createElement('img');
    image.className = 'kk-facet__vendor-logo';
    image.src = logo.url;
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.width = 36;
    image.height = 24;
    image.loading = 'lazy';
    image.decoding = 'async';
    slot.appendChild(image);
  }

  function hydrateVendorLogoSlots(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slots = [];

    if (scope.matches && scope.matches('[data-kk-vendor-logo-slot]')) {
      slots.push(scope);
    }

    scope.querySelectorAll('[data-kk-vendor-logo-slot]').forEach(function (slot) {
      slots.push(slot);
    });

    if (!slots.length) {
      return;
    }

    fetchVendorLogos().then(function () {
      slots.forEach(hydrateVendorLogoSlot);
    });
  }

  function queueVendorLogoHydration(root) {
    window.clearTimeout(hydrationTimer);
    hydrationTimer = window.setTimeout(function () {
      hydrationTimer = null;
      hydrateVendorLogoSlots(root || document);
    }, 0);
  }

  function initVendorLogos() {
    hydrateVendorLogoSlots(document);

    if (!window.MutationObserver) {
      return;
    }

    new MutationObserver(function (mutations) {
      var shouldHydrate = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            (node.matches && node.matches('[data-kk-vendor-logo-slot]')) ||
            (node.querySelector && node.querySelector('[data-kk-vendor-logo-slot]'))
          );
        });
      });

      if (shouldHydrate) {
        queueVendorLogoHydration(document);
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVendorLogos);
  } else {
    initVendorLogos();
  }
}());
